import { Component, ElementRef, TemplateRef, Input, ViewChild, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppService } from '../app.service';
import { messageService } from '../message.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { PaginationService } from 'src/app/PaginationService';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import html2canvas from 'html2canvas';
import jspdf, { jsPDF } from 'jspdf';
import { qmsService } from '../qms/qms.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { DomSanitizer } from '@angular/platform-browser';
import { DatePipe } from '@angular/common';
import { StaticAuditTrailComponent } from '../support/static-audit-trail/static-audit-trail.component';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import * as moment from 'moment';
import { GridReorderComponent } from '../grid-reorder/grid-reorder.component';
export interface PopupData {
  title: string;
}
interface DropDownInterface {
  codelistCode: any;
  codelistName: any;
}
@Component({
  selector: 'app-tms-user-manage-trainings-report',
  templateUrl: './tms-user-manage-trainings-report.component.html',
  styleUrls: ['./tms-user-manage-trainings-report.component.scss']
})
export class TmsUserManageTrainingsReportComponent implements OnInit {
  selectedStatus: any;
  popupData: PopupData = {
    title: ''
  };
  @Input() tmsReport: any = {};
  @Input() showMarkAsCompleteAndRetake: any;
  ClickedSearchVal: any;
  ClickedStatusVal: any;
  isProcessing = false;
  selectedOption: any;
  communicationData: any = {};
  searchUserName: any;
  specificIntervalVal: boolean = false;
  markasCompletedBtndisable: boolean = false;
  searchUserId: any;
  chosenToUserId: any;
  chosenToUserName: any;
  searchOneQmsUserTrainingsRepVw: any;
  getOneQmsUsersTrainingsRepVwDetails: any = [];
  getOneQmsUsersTrainingsRepVw: any = [];
  getOneQmsUsersTrainingsRepVwDetailsUserAndTraining: any = [];
  searchByDepartmentCodeMain: any = [];
  searchByInstructorTrainer: any = [];
  selectedInstructorTrainer: any;
  searchVals: any;
  additionalSearchVal: any;
  selectedIntervalValue: any = []
  selectedStageValue: any = [];
  markResult: any;
  resultType: any;
  showOnlyConsider = false;
  showTrainingContents = false;
  totalVal = 0;
  yetToBeAttemptedVal = 0;
  attemptedVal = 0;
  completedAtAttemptedVal = 0;
  failedAtAttemptedChartVal = 0;
  withdrawnAtAttemptedChartVal = 0;
  scheduledAtAttemptedChartVal = 0;
  passPerValForAll: any = 0;
  inprogressVal = 0;
  passedVal = 0;
  failedVal = 0;
  withdrawnVal = 0;
  scheduledVal = 0;
  passPerVal: any = 0;
  lockedVal = 0;
  completedVal = 0;
  notCompletedVal = 0;
  overdueVal = 0;
  pendingVal = 0;
  lockedOverdueVal = 0;
  chartOptionsForUser: any;
  dropDownForCategories: any = [];
  getTmsInstructorTrainerData: any = [];
  dropDownForLangauge: any = [];
  dropDownForOrg: any = [];
  cards: any = [];
  labels: any = [];
  icons: any
  selectedOverDue: any = [];
  type: any;
  repType: any;
  duedate: any;
  comments: any;
  retakeDuedateValue: any;
  popupVal: any;
  dateRangeValueDropdown: any = [];
  childGridShow: any;
  dateCustomClasses: DatepickerDateCustomClasses[];
  afterClickGenrate: boolean = false;
  notCompleted: boolean = false;
  teamUserLevel: boolean = false;
  departmentUserLevel: boolean = false;
  grouphTrainingLevel: boolean = false;
  instructorTrainingLevel: boolean = false;
  stageAndStatus: any = [];
  showTrainerLevel: boolean = false;
  stageValueDropdown: any = [];
  tmsReportchart: any;
  totalList: any = [];
  statusList: any = [];
  colorList: any = [];
  chartList: any = [];
  trainingsList: any;
  trainingListVal: any;
  heddingListVal: any;
  groupListVal: any;
  fromDate: any;
  toDate: any;
  tableReportDataList: any = [];
  dropDownForInterval: any = [];
  dropDownForDateRange: any = [];
  statusValueDropdown: any = [];
  selectedStatusValue: any = [];
  intervalValueDropdown: any = [];
  selectedDateRangeValue: any = [];
  showSpecificInterval: boolean = false;
  selectedTrainingCategory: any = [];
  categoryCount: any;
  showTables: boolean = false;
  pagedItems2: any;
  today: Date = new Date();
  getOneQmsUsersTrainingsRepVwTrainingCountByOr: any = [];
  getOneQmsUsersTrainingsRepVwUserCountByor: any = [];
  itemsPerPage3rd = 5;
  currentPage3rd = 1;
  totalPages3rd = 0;
  maxSize3rd = 3;
  collectionSize3rd: number;
  perPage3rd = 10;
  calculateTotalPages3rd: number;

  itemsPerPage4th = 5;
  currentPage4th = 1;
  totalPages4th = 0;
  maxSize4th = 3;
  collectionSize4th: number;
  perPage4th = 10;
  calculateTotalPages4th: number;

  pager3rd: any = {};
  pager4th: any = {};
  pagedItems3rd: any[];
  pagedItems4th: any[];
  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  reportFooterFieldValidation: any;
  groupSearchText: string = '';
  designationSearchText: string = '';
  departmentSearchText: string = '';
  categorySearchText: string = '';
  languageSearchText: string = '';
  trainerSearchText: string = '';
  pdfSearchText: string = '';
  searchByReportCodeMain: string = '';

  searchByReson: any = null;
  resonSearchText: string = '';
  showUserSearchGrid: boolean;
  noUserAlert: boolean = false;
  showInstructorTrainingSearchGrid: boolean;
  searchByUserName: any = null;
  searchByFirstName: any = null;
  searchByLastName: any = null;
  searchByDesignationCode: any = null;
  searchByDepartmentCode: any = null;
  searchingByStatusCode: any = [];
  designationCodeValue: any;
  departmentCodeValue: any;
  statusCodeValue: any;
  searchOneQmsUserVwDetails: any;
  getOneQmsUsersVwDetails: any = [];
  searchUserParentCheckBox: boolean = false;
  currentIndex: any;
  previousIndex: any = null;
  dealingWith: any = false;


  designationListDropdown: any = [];
  departmentListDropdown: any = [];
  selectedDesignationValue: any;
  selectedDepartmentValue: any;
  dropDownForDesignation: any = [];
  dropDownForDepartment: any = [];
  currentRetakeType: string = '';
  currentType: any;
  currentWhereVal: any;
  constructor(public appService: AppService, public router: Router, public datePipe: DatePipe, public service: messageService, public dialog: MatDialog,
    public snackBar: MatSnackBar, public paginationService: PaginationService, public message: messageService,
    public qmsservice: qmsService, public elem: ElementRef, public sanitizer: DomSanitizer) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];
    appService.isProcessingRep = false;
  }
  @ViewChild('chartContainerTMS') chartContainerTMS: ElementRef;
  @ViewChild('retakeAndMarkasCompletedPopup', { static: true }) retakeAndMarkasCompletedPopup: TemplateRef<any>;
  visibleretakePopup: MatDialogRef<TemplateRef<any>>;
  retakeAndMarkasCompletedPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },

  };

  dateFormat: any = this.appService.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center',
    minDate: this.today
  }
  datePickerConfigurationComplete = {
    dateInputFormat: 'DD-MMM-YYYY',
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center',
  }
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }
  onDesignationSelect(event: any, item: any) {
  }
  onDepartmentSelect(event: any, item: any) { }
  changeExpcetedClosureOnDate(items: any) {
    this.retakeDuedateValue = document.getElementById('expcetedClosureOn-validation') as HTMLInputElement;
    if (items != null || items != undefined) {
      if (this.retakeDuedateValue != undefined) {
        this.retakeDuedateValue.style.color = '';
      }
    } else {
      this.retakeDuedateValue.style.color = 'red';
    }
  }
  onTypeChanged(data: any) {
    this.afterClickGenrate = false;
    this.ClickedSearchVal = "";
    this.ClickedStatusVal = "";
    this.searchByDepartmentCodeMain = [];
    this.totalVal = 0;
    this.attemptedVal = 0;
    this.yetToBeAttemptedVal = 0;
    this.completedAtAttemptedVal = 0;
    this.failedAtAttemptedChartVal = 0;
    this.withdrawnAtAttemptedChartVal = 0;
    this.scheduledAtAttemptedChartVal = 0;
    this.passPerValForAll = 0;
    this.inprogressVal = 0;
    this.passedVal = 0;
    this.failedVal = 0;
    this.withdrawnVal = 0;
    this.scheduledVal = 0;
    this.lockedVal = 0;
    this.completedVal = 0;
    this.overdueVal = 0;
    this.pendingVal = 0;
    this.lockedOverdueVal = 0;
    this.tmsUserTrainingsRepVwDataForGrid = [];
    this.searchUserName = "";
    this.getSelectedTrainingName = "";
    this.childGridShow = false;
    this.notCompleted = false;
    this.teamUserLevel = false;
    this.departmentUserLevel = false;
    this.grouphTrainingLevel = false;
    this.instructorTrainingLevel = false;
    this.getOneQmsUsersTrainingsRepVwDetailsUserAndTraining = [];
    this.totalList = [];
    this.statusList = [];
    this.colorList = [];
    if (this.selectedOption == 'Instructor Trainings') {
      this.instructorTrainingLevel = true;
    }
  }

  @ViewChild('searchUserPopup', { static: true }) searchUserPopup: TemplateRef<any>;
  visibleSearchUserPopup: MatDialogRef<TemplateRef<any>>;

  searchUserPopupConfig = {
    width: '75%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  openSearchUserPopup(value: any) {
    this.totalVal = 0;
    this.multiUsersArray = [];
    this.dealingWith = value;
    this.showUserSearchGrid = false;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    [this.searchByDesignationCode, this.searchByDepartmentCode, this.chosenToUserId, this.chosenToUserName] = [null, null, [], []];
    this.popupData.title = "Search User(s)";
    this.visibleSearchUserPopup = this.dialog.open(this.searchUserPopup, this.searchUserPopupConfig);
  }
  selectBoxForDesignation() {
    this.designationListDropdown = [];
    this.designationListDropdown = this.dropDownForDesignation.map((item: DropDownInterface) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }
  selectBoxForDepartment() {
    this.departmentListDropdown = [];
    this.departmentListDropdown = this.dropDownForDepartment.map((item: DropDownInterface) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }));
  }
  searchUser() {
    this.isProcessing = true;
    let searchByUserName = "";
    if (this.searchByDesignationCode) {
      this.designationCodeValue = this.searchByDesignationCode;
    } else {
      this.designationCodeValue = null;
    }
    if (this.searchByDepartmentCode) {
      this.departmentCodeValue = this.searchByDepartmentCode;
    } else {
      this.departmentCodeValue = null;
    }
    if (this.searchByUserName) {
      searchByUserName = this.searchByUserName.toUpperCase();
    } else {
      this.searchByUserName = '';
    }
    this.searchOneQmsUserVwDetails = {
      userName: searchByUserName,
      firstName: this.searchByFirstName,
      lastName: this.searchByLastName,
      designationCode: this.designationCodeValue,
      departmentCode: this.departmentCodeValue,
      status: "active"
    };
    this.appService.getOneQmsUsersVwDetails(this.searchOneQmsUserVwDetails).subscribe((data: any) => {
      this.getOneQmsUsersVwDetails = data;
      this.searchUserParentCheckBox = false;
      this.showUserSearchGrid = true;
      this.isProcessing = false;
    })
  }
  multiUsersArray: any = [];
  selectAllUsersChanged(e: any) {
    if (e.target.checked) {
      this.multiUsersArray = [];
      this.getOneQmsUsersVwDetails.every((user: any) => {
        if (user.emailAddress) {
          user.searchUserChildCheckBox = true;
          this.multiUsersArray.push({ userId: user.userId, userName: user.userName });
        }
        return true;
      })
    } else {
      this.multiUsersArray = [];
      this.getOneQmsUsersVwDetails.every((user: any) => {
        if (user.emailAddress) { user.searchUserChildCheckBox = false; } return true;
      })
    }
  }

  selectAllTrainings(e: any) {
    if (e.target.checked) {
      this.multiUsersArray = [];
      this.getTmsTrainingDetailsTableData.forEach((training: any) => {
        if (training.trainingName) {
          training.searchTrainingChildCheckBoxs = true; // Updated property
          this.multiUsersArray.push({ trainingId: training.trainingId, trainingName: training.trainingName });
        }
      });
      this.searchUserParentCheckBox = true;
    } else {
      this.multiUsersArray = [];
      this.getTmsTrainingDetailsTableData.forEach((training: any) => {
        if (training.trainingName) {
          training.searchTrainingChildCheckBoxs = false; // Updated property
        }
      });
      this.searchUserParentCheckBox = false;
    }
  }
  onChildCheckBoxChanged(e: any, listOfUsersData: any, idx: any) {
    if (e.target.checked) {
      listOfUsersData.searchUserChildCheckBox = true;
      if (!this.multiUsersArray.some((storedUser: any) => storedUser.userId === listOfUsersData.userId)) {
        this.multiUsersArray.push({ userId: listOfUsersData.userId, userName: listOfUsersData.userName });
      }
      this.getOneQmsUsersVwDetails.every((allUsers: any) => { if (allUsers.searchUserChildCheckBox) { this.searchUserParentCheckBox = true; } return true; })
    } else {
      listOfUsersData.searchUserChildCheckBox = false;
      const removal = this.getOneQmsUsersVwDetails.findIndex((removableUser: any) => removableUser.userId == listOfUsersData.userId);
      if (removal > -1) this.multiUsersArray.splice(removal, 1);

      if (this.getOneQmsUsersVwDetails.some((allUsers: any) => !allUsers.searchUserChildCheckBox)) {
        this.searchUserParentCheckBox = false;
      }
    }
    console.log(this.multiUsersArray, "this.qmsUsersList");
  }
  onStageValueSelect(item: any) {

    this.statusValueDropdown = [];
    for (const stageStatus of this.stageAndStatus) {
      if (stageStatus.stageName === item.valueExp) {
        const statusArray = stageStatus.listOfStatus
          .split(',')
          .map((status: string) => status.trim())
          .filter((status: string) => !this.statusValueDropdown.includes(status));
        this.statusValueDropdown = [...this.statusValueDropdown, ...statusArray];
      }
    }
  }
  showOnlyNotConsiderRtp(e: any) {
    if (e.checked) {
      this.pagedItemsSecond = [];
      this.pagedItemsSecond1 = [];
      this.showOnlyConsider = true;
      this.searchByReson = null;
      this.pagedItemsSecond = this.tmsUserTrainingsRepVwDataForGrid.filter(
        (item: any) => item.CONSIDERED_FOR_REPORT === 'N'
      );
      console.log(this.pagedItemsSecond)
      this.pagedItemsSecond1 = this.tmsUserTrainingsRepVwDataForGrid.filter(
        (item: any) => item.CONSIDERED_FOR_REPORT === 'N'
      );
      console.log(this.pagedItemsSecond1)
      this.calculateTotalPagesSecond = this.collectionSizeSecond / this.perPageSecond;
      this.pagerSecond.totalPages = undefined;
      this.collectionSizeSecond = this.pagedItemsSecond.length;
      this.totalPagesSecond = Math.ceil(this.pagedItemsSecond.length / this.itemsPerPageSecond);
      this.setPageSecond1(1, 0);
      console.log(this.pagedItemsSecond)
    } else {
      this.pagedItemsSecond = [];
      this.showOnlyConsider = false;
      this.searchByReson = null;
      this.showTrainingContents = false;
      this.calculateTotalPagesSecond = this.collectionSizeSecond / this.perPageSecond;
      this.pagerSecond.totalPages = undefined;
      this.collectionSizeSecond = this.tmsUserTrainingsRepVwDataForGrid.length;
      this.totalPagesSecond = Math.ceil(this.tmsUserTrainingsRepVwDataForGrid.length / this.itemsPerPageSecond);
      this.setPageSecond(1, 0);
    }
  }
  resonSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.showOnlyConsider = true;
        this.searchByReson = item.valueExp;
        this.pagedItemsSecond = [];
        this.pagedItemsSecond1 = [];
        this.pagedItemsSecond = this.tmsUserTrainingsRepVwDataForGrid.filter(
          (item: any) => item.REASON_FOR_NOT_CONSIDERED_AT_REPORT === this.searchByReson
        );
        this.pagedItemsSecond1 = this.tmsUserTrainingsRepVwDataForGrid.filter(
          (item: any) => item.REASON_FOR_NOT_CONSIDERED_AT_REPORT === this.searchByReson
        );
        this.calculateTotalPagesSecond = this.collectionSizeSecond / this.perPageSecond;
        this.pagerSecond.totalPages = undefined;
        this.collectionSizeSecond = this.pagedItemsSecond.length;
        this.totalPagesSecond = Math.ceil(this.pagedItemsSecond.length / this.itemsPerPageSecond);
        this.setPageSecond1(1, 0);
        console.log(this.pagedItemsSecond)
      } else {
        console.log()
        this.pagedItemsSecond = [];
        this.pagedItemsSecond1 = [];
        this.showOnlyConsider = true;
        this.searchByReson = null;
        this.pagedItemsSecond = this.tmsUserTrainingsRepVwDataForGrid.filter(
          (item: any) => item.CONSIDERED_FOR_REPORT === 'N'
        );
        this.pagedItemsSecond1 = this.tmsUserTrainingsRepVwDataForGrid.filter(
          (item: any) => item.CONSIDERED_FOR_REPORT === 'N'
        );
        this.calculateTotalPagesSecond = this.collectionSizeSecond / this.perPageSecond;
        this.pagerSecond.totalPages = undefined;
        this.collectionSizeSecond = this.pagedItemsSecond.length;
        this.totalPagesSecond = Math.ceil(this.pagedItemsSecond.length / this.itemsPerPageSecond);
        this.setPageSecond1(1, 0);
        console.log(this.pagedItemsSecond)
      }

    }
  }
  specificIntervalFun(e: any) {
    if (e.checked) {
      this.specificIntervalVal = true;
      this.showSpecificInterval = true;
      this.selectedDateRangeValue = [{
        valueExp: 'CREATED',
        displayExp: 'CREATED'
      }];
      this.fromDate = null;
      this.toDate = null;
      this.selectedIntervalValue = [{
        valueExp: 'MONTH',
        displayExp: 'MONTH'
      }]
    } else {
      this.specificIntervalVal = false;
      this.showSpecificInterval = false;
    }
  }
  selectBoxForDateRange() {
    this.dateRangeValueDropdown = [];
    for (const dateRange of this.dropDownForDateRange) {
      this.dateRangeValueDropdown = this.dateRangeValueDropdown.concat({
        valueExp: dateRange.codelistCode,
        displayExp: dateRange.codelistName
      });
    }
  }
  selectBoxForInterval() {
    this.intervalValueDropdown = [];
    for (const interval of this.dropDownForInterval) {
      this.intervalValueDropdown = this.intervalValueDropdown.concat({
        valueExp: interval.codelistCode,
        displayExp: interval.codelistName
      });
    }
  }
  resetSearchManagerGridDataFunction() {
    this.isProcessing = true;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.getOneQmsUsersVwDetails = [];
    this.showUserSearchGrid = false;
    this.isProcessing = false;
  }
  setUser() {
    this.afterClickGenrate = false;
    this.noUserAlert = false;
    this.searchUserName = this.multiUsersArray.map((user: any) => user.userName).join(',');
    this.chosenToUserId = this.multiUsersArray.map((user: any) => user.userId).join(',');
    if (this.searchUserName != "" && this.searchUserName != null && this.searchUserName != undefined) {
      this.visibleSearchUserPopup.close();
    } else {
      this.noUserAlert = true;
    }
  }
  addTrainingNameFunction() {
    this.afterClickGenrate = false;
    this.noUserAlert = false;

    if (this.multiUsersArray.length > 50) {

      alert("You cannot select more than 50 trainings.");

    } else {

      this.getSelectedTrainingId = this.multiUsersArray.map((training: any) => training.trainingId).join(',');
      this.getSelectedTrainingName = this.multiUsersArray.map((training: any) => training.trainingName).join(',');
      this.searchVals = this.getSelectedTrainingId;

      if (this.searchVals !== "" && this.searchVals !== null && this.searchVals !== undefined) {
        this.visibleSearchTrainingPopup.close();
      } else {
        this.noUserAlert = true;
      }
    }
  }

  resetFunction() {
    this.pagedItems7 = [];
    this.pagedItems2 = [];
    this.afterClickGenrate = false;
    this.ClickedSearchVal = "";
    this.ClickedStatusVal = "";
    this.searchByDepartmentCodeMain = [];
    this.getSelectedTrainingId = "";

    this.totalVal = 0;
    this.attemptedVal = 0;
    this.yetToBeAttemptedVal = 0;
    this.completedAtAttemptedVal = 0;
    this.failedAtAttemptedChartVal = 0;
    this.withdrawnAtAttemptedChartVal = 0;
    this.scheduledAtAttemptedChartVal = 0;
    this.passPerValForAll = 0;
    this.inprogressVal = 0;
    this.passedVal = 0;
    this.failedVal = 0;
    this.withdrawnVal = 0;
    this.scheduledVal = 0;
    this.lockedVal = 0;
    this.completedVal = 0;
    this.overdueVal = 0;
    this.pendingVal = 0;
    this.lockedOverdueVal = 0;
    this.tmsUserTrainingsRepVwDataForGrid = [];
    this.searchUserName = "";
    this.chosenToUserId = "";
    this.chosenToUserName = "";
    this.getSelectedTrainingName = "";
    this.childGridShow = false;
    this.notCompleted = false;
    this.teamUserLevel = false;
    this.departmentUserLevel = false;
    this.grouphTrainingLevel = false;
    this.instructorTrainingLevel = false;
    this.getOneQmsUsersTrainingsRepVwDetailsUserAndTraining = [];
    this.totalList = [];
    this.statusList = [];
    this.colorList = [];
    this.selectedStatus = "";
    this.specificIntervalVal = false;
    this.selectedTrainingCategory = "";
    this.selectedOverDue = "";
    this.getSelectedInstructorTrainingName = "";
    this.searchByInstructorTrainer = [];
    this.pagedItems = [];
    this.pagedItemsSecond = [];
    this.getOneQmsUsersTrainingsRepVw = {};
    this.tmsUserTrainingsRepVwDataForGrid = {};
    this.searchValue = "";
    this.searchByReportCodeMain = "";
    this.showTrainerLevel = false;
  }

  getUsers() {
    this.pagedItemsSecond = [];
    if (this.selectedOption == 'Users') {
      if (this.searchByReportCodeMain) {
        this.searchUserId = this.chosenToUserId;
        if (this.searchUserId && this.searchUserId.length > 0) {
          this.newRun("user", this.chosenToUserId.toString());
        } else {
          this.newRun("user", "01010");
        }
      } else {
        const field = document.getElementById('manageReportNameAlert') as HTMLInputElement;
        field.style.color = 'red';
      }
    } else if (this.selectedOption == 'Trainings') {
      if (this.searchByReportCodeMain) {
        if (this.getSelectedTrainingId) {
          this.newRun("tr", this.getSelectedTrainingId.toString());
        } else {
          this.newRun("tr", "01010");
        }
      } else {
        const field = document.getElementById('manageReportNameAlert') as HTMLInputElement;
        field.style.color = 'red';
      }
    }
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
  }

  setPage2(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.tableReportDataList.length, page, this.perPage, targetpage);
    if (this.tableReportDataList.length > 0) {
      this.pagedItems2 = this.tableReportDataList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCall2(value: number) {
    this.perPage = value;
    this.setPage2(this.pager.currentPage, 0);
  }
  setPage1(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.trainingsList.length, page, this.perPage, targetpage);
    if (this.trainingsList.length > 0) {
      this.pagedItems = this.trainingsList.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCall1(value: number) {
    this.perPage = value;
    this.setPage1(this.pager.currentPage, 0);
  }
  pagedItems7: any[];
  setPage7(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.trainingListVal.length, page, this.perPage, targetpage);
    if (this.trainingListVal.length > 0) {
      this.pagedItems7 = this.trainingListVal.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCall7(value: number) {
    this.perPage = value;
    this.setPage7(this.pager.currentPage, 0);
  }

  newRun(type: any, val: any) {
    console.log("type=", type);
    console.log("val=", val);
    this.getOneQmsUsersTrainingsRepVw = [];
    this.tmsUserTrainingsRepVwDataForGrid = [];
    this.isProcessing = true;
    let i = 0;
    this.afterClickGenrate = false;
    this.totalVal = 0;
    this.attemptedVal = 0;
    this.yetToBeAttemptedVal = 0;
    this.completedAtAttemptedVal = 0;
    this.failedAtAttemptedChartVal = 0;
    this.withdrawnAtAttemptedChartVal = 0;
    this.scheduledAtAttemptedChartVal = 0;
    this.passPerValForAll = 0;
    this.inprogressVal = 0;
    this.passedVal = 0;
    this.failedVal = 0;
    this.withdrawnVal = 0;
    this.scheduledVal = 0;
    this.lockedVal = 0;
    this.completedVal = 0;
    this.overdueVal = 0;
    this.pendingVal = 0;
    this.lockedOverdueVal = 0;
    this.chartList = [];
    let attaptedVal = "";
    if (this.message.showRetakeAndMarkasCompleted) {
      attaptedVal = "noNeedConsiderForReport"
    } else {
      attaptedVal = "NeedConsiderForReport"
    }
    this.appService.getOneQmsUserTrainingsRepVwMain(type, val, attaptedVal).subscribe((data: any) => {
      this.afterClickGenrate = true;
      this.getOneQmsUsersTrainingsRepVwDetails = data;
      this.calculateTotalPages = this.collectionSize / this.perPage;
      this.pager.totalPages = undefined;
      this.collectionSize = this.getOneQmsUsersTrainingsRepVwDetails.length;
      this.totalPages = Math.ceil(this.getOneQmsUsersTrainingsRepVwDetails.length / this.itemsPerPage);
      this.setPageMain(1, 0);
      console.log("this.getOneQmsUsersTrainingsRepVwDetails=", this.getOneQmsUsersTrainingsRepVwDetails)
      data.forEach((item: any, index: any) => {
        this.totalVal += item.total;
        this.attemptedVal += item.attempted;
        this.completedAtAttemptedVal += item.completedAtAttemptedChart;
        this.failedAtAttemptedChartVal += item.failedAtAttemptedChart;
        this.withdrawnAtAttemptedChartVal += item.withdrawnAtAttemptedChart;
        this.scheduledAtAttemptedChartVal += item.scheduledAtAttemptedChart;
        this.yetToBeAttemptedVal += item.yetToBeAttempted;
        this.passPerValForAll = (this.completedAtAttemptedVal / this.totalVal * 100).toFixed(1);
        this.pendingVal += item.pending;
        this.inprogressVal += item.inprogress;
        this.failedVal += item.failed;
        this.withdrawnVal += item.withdrawn;
        this.scheduledVal += item.scheduled;
        this.completedVal += item.completed;
        this.overdueVal += item.overdue;
        this.lockedVal += item.locked;
        this.passPerVal = (this.completedVal / this.totalVal * 100).toFixed(1);
      });
      console.log("data12345", this.completedAtAttemptedVal)
      if (this.notCompleted) {
        this.chartList.push(
          { lable: "Pending", value: this.pendingVal, color: "yellow" },
          { lable: "Attempted", value: this.attemptedVal, color: "DodgerBlue" },
          { lable: "Inprogress", value: this.inprogressVal, color: "green" },
          { lable: "Completed", value: this.completedVal, color: "green" },
          { lable: "Failed", value: this.failedVal, color: "red" },
          { lable: "Withdrawn", value: this.withdrawnVal, color: "red" },
          { lable: "Scheduled", value: this.scheduledVal, color: "gray" },
          { lable: "Overdue", value: this.overdueVal, color: "green" },
          { lable: "locked", value: this.lockedVal, color: "green" }
        );
      } else {
        this.chartList.push(
          { lable: "Attempted", value: this.attemptedVal, color: "DodgerBlue" },
          { lable: "Yet To Be Attempted", value: this.yetToBeAttemptedVal, color: "yellow" },
          { lable: "Scheduled At Attempted Chart", value: this.scheduledAtAttemptedChartVal, color: "DodgerBlue" },
          { lable: "Failed At Attempted Chart", value: this.failedAtAttemptedChartVal, color: "green" },
          { lable: "Withdrawn At Attempted Chart", value: this.withdrawnAtAttemptedChartVal, color: "red" },
          { lable: "Completed At Attempted", value: this.completedAtAttemptedVal, color: "green" }
        );
      }

      this.isProcessing = false;
    })
  }

  setPageMain(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.getOneQmsUsersTrainingsRepVwDetails.length, page, this.perPage, targetpage);
    if (this.getOneQmsUsersTrainingsRepVwDetails.length > 0) {
      this.pagedItemsMain = this.getOneQmsUsersTrainingsRepVwDetails.slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCallMain(value: number) {
    this.perPage = value;
    this.setPageMain(this.pager.currentPage, 0);
  }
  getUserAndTraining() {
    this.getOneQmsUsersTrainingsRepVwDetailsUserAndTraining = [];
    this.isProcessing = true;
    if (this.selectedOption == 'Team Member Trainings') {
      this.searchOneQmsUserTrainingsRepVw = {

        type: "rm",
        searchValue: this.chosenToUserId.toString()
      };
    }
    this.appService.getOneQmsUserTrainingsRepVwUserLevel(this.searchOneQmsUserTrainingsRepVw).subscribe((data: any) => {
      this.getOneQmsUsersTrainingsRepVwDetailsUserAndTraining = data;
      this.isProcessing = false;
    })
  }


  cancelSearchManagerFunction() {
    this.noUserAlert = false;
    this.visibleSearchUserPopup.close();
  }
  //dynamic grid
  snackbarRef: any;
  searchText: any;
  searchValue: any;
  _temp: any = {};
  columnLists: any = {};
  tmsUserTrainingsRepVwDataForGrid: any = [];
  makeStickyColumns: any;
  dataTypeList: any = [];
  visibleDataGrid: boolean = false;
  itemsPerPage = 5;
  currentPage = 1;
  totalPages = 0;
  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  calculateTotalPages: number;
  itemsPerPageSecond = 5;
  currentPageSecond = 1;
  totalPagesSecond = 0;
  maxSizeSecond = 3;
  collectionSizeSecond: number;
  perPageSecond = 10;
  calculateTotalPagesSecond: number;
  pagedItemsMain: any[];
  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  users: any[];
  pager: any = {};
  pagerSecond: any = {};
  pagedItems: any[];
  pagedItemsSecond: any[];
  pagedItemsSecond1: any[];
  error = '';
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager = this.paginationService.getPager(this.tmsUserTrainingsRepVwDataForGrid.length, page, this.perPage, targetpage);
    if (this.tmsUserTrainingsRepVwDataForGrid.length > 0) {
      this.pagedItems = this.tmsUserTrainingsRepVwDataForGrid
        .slice(this.pager.startIndex, this.pager.endIndex + 1);
    }
  }
  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  getcallMethod() {
    this.tmsUserTrainingsRepVwDataForGrid = [];
    const data = {

      gridName: "USER_TRAINING_REPORT",
      groupId: null
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {

        response.orderByClause ??= "";
        this.makeStickyColumns = response.fixedFieldCnt;
        console.log(this.searchVals);
        const data1: any = {

          gridName: "TMS_USER_TRAININGS_REP_VW",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          searchVal: this.searchVals,
          additionalSearchVal: this.additionalSearchVal,
          searchStatus: this.type,
          repType: this.repType,
          manualEntryDataFields: response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || ""
        }
        this.appService.getDynamicGridData(data1).subscribe({
          next: (response1: any) => {
            this.tmsUserTrainingsRepVwDataForGrid = response1;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            let rendereddata: any;
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const fieldSize of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(fieldSize + 'px');
            }
            for (let y = 0; y < this.columnLists.columnsListarray.length; y++) {
              for (let k = this.columnLists.invisibleColumnarray.length - 1; k >= 0; k--) {
                if (this.columnLists.columnsListarray[y] === this.columnLists.invisibleColumnarray[k]) {
                  this.columnLists.columnsListarray.splice(y, 1);
                  this.columnLists.fieldColumnarray.splice(y, 1);
                  this.columnLists.fieldSizeListArray.splice(y, 1);
                }
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const dataType of this.dataTypeList) {
                  if (dataType.columnName === this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = dataType.fieldType;
                  }
                }
              }
              for (const row of this.tmsUserTrainingsRepVwDataForGrid) {
                for (const dataType of this.dataTypeList) {
                  if (dataType.fieldType === 'CHECKBOX') {
                    row[dataType.columnName] = row[dataType.columnName] === "Y";
                  }
                }
              }
              this.calculateTotalPages = this.collectionSize / this.perPage;
              this.pager.totalPages = undefined;
              this.setPage(1, 0);
            });
            this.message.gridList = this.tmsUserTrainingsRepVwDataForGrid;
            this.collectionSize = this.tmsUserTrainingsRepVwDataForGrid.length;
            this.totalPages = Math.ceil(this.tmsUserTrainingsRepVwDataForGrid.length / this.itemsPerPage);
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
        this.isProcessing = false;
      }, error: (error) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  applyFilter3(column: string, event: Event): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.pagedItems = this.tmsUserTrainingsRepVwDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
      this.searchValue = '';
    } else {
      this.pagedItems = this.tmsUserTrainingsRepVwDataForGrid.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)
      );
    }
  }

  counts: any;
  cssfunction(ix: number) {
    let elements1 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-col1');
    let index1 = 1;
    let headerWidth = 0;
    elements1.forEach((header: any, key: any) => {
      for (let i = 1; i <= this.makeStickyColumns; i++) {
        if (index1 == i) {
          header.style.position = 'sticky';
          header.style.background = 'white';
          if (index1 > 1) {
            headerWidth += 200;
            header.style.left = headerWidth + 'px';
          } else {
            headerWidth = 60;
            header.style.left = headerWidth + 'px';
          }
        }
      }
      index1++;
    })

    let elements2 = this.elem.nativeElement.querySelectorAll('.sticky-dynamic-row1');
    let index2 = 1;
    let lengthOfColumns = this.columnLists.columnsListarray1.length;
    let colWidth = 0;
    elements2.forEach((column: any, key: any) => {
      for (let j = 1; j <= this.makeStickyColumns; j++) {
        if (index2 == j) {
          column.style.position = 'sticky';
          column.style.background = 'white';
          column.style.textDecoration = "underline";
          column.style.color = "blue";
          column.style.cursor = "pointer";
          if (index2 > 1) {
            colWidth += 200;
            let previousColumn = elements2[key - 1];
            console.log(previousColumn.style.width);
            column.style.left = colWidth + 'px';
          } else {
            colWidth = 60;
            column.style.left = colWidth + 'px';
          }
          column.addEventListener('click', this.onClick.bind(this));
        }
      }
      if (index2 == (lengthOfColumns - 1)) {
        index2 = 0;
      } else {
        index2++;
      }
    })
  }

  onClick(event: any) {

    this.snackbarRef?.dismiss?.();
    let templateName = event.target.innerText;
    const filteredQmsQuestionnaireTemplateData = this.tmsUserTrainingsRepVwDataForGrid.filter(
      (x: any) => x.TEMPLATE_NAME === templateName
    );
    if (filteredQmsQuestionnaireTemplateData.length > 0) {
      this.message.templateIdFromQmsQuestionnaireTemplate = filteredQmsQuestionnaireTemplateData[0].TEMPLATE_ID;
    }
    this.router.navigate(['dashboard/qmsQuestionnaireTemplateQuestion']);
  }

  parentCheckBox: boolean = false;
  childCheckBoxs: boolean = false;
  dataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked) {
      this.childCheckBoxs = true;
      this.tmsUserTrainingsRepVwDataForGrid.forEach((item: { childCheckBoxs: boolean; }) => {
        item.childCheckBoxs = true;
      });
    } else {
      this.childCheckBoxs = false;
      this.tmsUserTrainingsRepVwDataForGrid.forEach((item: { childCheckBoxs: boolean; }) => {
        item.childCheckBoxs = false;
      });
    }
  }

  dataGridChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.childCheckBoxs = true;
    } else {
      list.childCheckBoxs = false;
    }
  }

  visibleAddButton: boolean;
  visibleEditButton: boolean;
  refreshGridData() {
    this.isProcessing = true;
    this.getcallMethod();
  }
  getUserStatusDetails(type: any) {
    this.ClickedSearchVal = "";
    this.ClickedStatusVal = "";
    this.parentCheckBox = false;
    this.childCheckBoxs = false;
    if (this.selectedOption == 'Users') {
      this.repType = "user";
      this.ClickedSearchVal = this.searchUserName;
      this.ClickedStatusVal = type;
    } else if (this.selectedOption == 'Trainings') {
      this.ClickedSearchVal = this.getSelectedTrainingName;
      this.ClickedStatusVal = type;
      this.repType = "trainings";
    } else if (this.selectedOption == 'Instructor Trainings') {
      this.ClickedSearchVal = this.getSelectedInstructorTrainingName;
      this.ClickedStatusVal = type;
      if (this.showTrainerLevel) {
        this.repType = "inT";
      } else {
        this.repType = "in";
      }
    }
    this.ClickedStatusVal = type;
    this.childGridShow = true;
    this.additionalSearchVal = null;
    this.type = type;
    this.getcallMethod();
  }
  selectedDepVal: any = [];
  onModuleSelect(item: any) {
    this.selectedDepVal = item.valueExp;
  }

  onModuleSelectAllnew(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        item.forEach((element: { valueExp: any; }) => {
          this.selectedDepVal.push({
            valueExp: element.valueExp
          });
        });
        console.log("data", this.selectedDepVal)
      })
    }
  }
  onModuleSelectAll(item: any) {
    this.selectedDepVal = [];
    item.forEach((element: { valueExp: any; }) => {
      this.selectedDepVal.push({
        valueExp: element.valueExp
      });
    });
  }
  selectedTraininerVal: any = [];
  onTraininerSelectAllnew(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.selectedTraininerVal = item;
      })
    }
  }

  // Instructor Training
  InstructorTrainingGroupTrainingFieldData: any = {};
  @ViewChild('searchInstructorTraining', { static: true }) searchInstructorTraining: TemplateRef<any>;
  visibleSearchInstructorTrainingPopup: MatDialogRef<TemplateRef<any>>;
  searchByInstructorTrainingName: any = null;
  searchByInstructorTrainingScheduleId: any = null;
  searchByVersion: any = [];
  searchByTrainerName: any = [];
  searchByTrainingMode: any = [];
  searchByStatus: any = [];
  searchTmsInstructorTrainingsVwDetails: any;
  getTmsInstructorTrainingDetailsTableData: any = [];
  showUserSearchInstructorTrainingGrid: any;
  getSelectedInstructorTrainingId: any;
  getSelectedInstructorTrainingName: string;
  searchInstructorTrainingConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  searchInstructorTrainingFunction() {
    console.log("data ====", this.multiUsersArray)
    this.multiUsersArray = [];
    this.getTmsInstructorTrainingDetailsTableData.forEach((training: any) => {
      if (training.trainingName) {
        training.searchTrainingChildCheckBoxs = false;
      }
    });
    this.showInstructorTrainingSearchGrid = false;
    this.showUserSearchInstructorTrainingGrid = false;
    this.searchByInstructorTrainingScheduleId = "";
    this.searchByInstructorTrainingName = "";
    this.searchByVersion = "";
    this.searchByTrainerName = "";
    this.searchByTrainingMode = "";
    this.searchByStatus = "";
    this.popupDataTitle.title = "Search Instructor Training";
    this.visibleSearchInstructorTrainingPopup = this.dialog.open(this.searchInstructorTraining, this.searchInstructorTrainingConfig);
  }
  searchInstructorTrainingGridDataFunction() {
    this.isProcessing = true;
    this.searchTmsTrainingsVwDetails = {
      trainingScheduleId: this.searchByInstructorTrainingScheduleId,
      trainingName: this.searchByInstructorTrainingName,
      version: this.searchByVersion,
      trainerName: this.searchByTrainerName,
      trainingMode: this.searchByTrainingMode,
      status: this.searchByStatus
    };
    this.appService.searchInstructorTrainingsByCondition(this.searchTmsTrainingsVwDetails).subscribe((response: any) => {
      this.getTmsInstructorTrainingDetailsTableData = response;
      this.showInstructorTrainingSearchGrid = true;
      this.isProcessing = false;
    })
  }
  resetSearchInstructorTrainingGridDataFunction() {
    this.isProcessing = true;
    this.searchByInstructorTrainingScheduleId = "";
    this.searchByInstructorTrainingName = "";
    this.searchByVersion = "";
    this.searchByTrainerName = "";
    this.searchByTrainingMode = "";
    this.searchByStatus = "";
    this.getTmsInstructorTrainingDetailsTableData = [];
    this.showUserSearchGrid = false;
    this.isProcessing = false;
  }
  selectAllInsTrainings(e: any) {
    if (e.target.checked) {
      this.multiUsersArray = [];
      this.getTmsInstructorTrainingDetailsTableData.forEach((training: any) => {
        if (training.trainingName) {
          training.searchTrainingChildCheckBoxs = true;
          this.multiUsersArray.push({ trainingId: training.trainingScheduleId, trainingName: training.trainingName });
        }
      });
    } else {
      this.multiUsersArray = [];
      this.getTmsInstructorTrainingDetailsTableData.forEach((training: any) => {
        if (training.trainingName) {
          training.searchTrainingChildCheckBoxs = false;
        }
      });
    }

    const anyChildChecked = this.getTmsInstructorTrainingDetailsTableData.some(
      (training: any) => training.searchTrainingChildCheckBoxs
    );
    e.target.checked = anyChildChecked;
  }
  searchInstructorTrainingChildCheckBoxChecked(e: any, listOfTrainingsVwDetails: any, idx: any) {
    if (e.target.checked) {
      listOfTrainingsVwDetails.searchTrainingChildCheckBoxs = true;
      if (!this.multiUsersArray.some((storedUser: any) => storedUser.trainingScheduleId === listOfTrainingsVwDetails.trainingScheduleId)) {
        this.multiUsersArray.push({ trainingId: listOfTrainingsVwDetails.trainingScheduleId, trainingName: listOfTrainingsVwDetails.trainingName });
      }
      this.getTmsInstructorTrainingDetailsTableData.every((allUsers: any) => { if (allUsers.searchTrainingChildCheckBoxs) { this.searchUserParentCheckBox = true; } return true; })
    } else {
      listOfTrainingsVwDetails.searchTrainingChildCheckBoxs = false;
      const removal = this.getTmsInstructorTrainingDetailsTableData.findIndex((removableUser: any) => removableUser.trainingScheduleId == listOfTrainingsVwDetails.trainingScheduleId);
      if (removal > -1) this.multiUsersArray.splice(removal, 1);

      if (this.getTmsInstructorTrainingDetailsTableData.some((allUsers: any) => !allUsers.searchTrainingChildCheckBoxs)) {
        this.searchUserParentCheckBox = false;
      }
    }
    if (e.target.checked) {
      this.searchByInstructorTrainingScheduleId = listOfTrainingsVwDetails.trainingScheduleId;
      this.getSelectedInstructorTrainingName = listOfTrainingsVwDetails.trainingName;
    } else {
      this.searchByInstructorTrainingScheduleId = null;
      this.getSelectedInstructorTrainingName = '';
    }
  }
  addInstructorTrainingNameFunction() {
    this.afterClickGenrate = false;
    this.getSelectedTrainingId = this.multiUsersArray.map((training: any) => training.trainingId).join(',');
    this.getSelectedInstructorTrainingName = this.multiUsersArray.map((training: any) => training.trainingName).join(',');
    console.log(this.getSelectedTrainingId + "----" + this.getSelectedInstructorTrainingName)
    this.searchVals = this.getSelectedTrainingId;
    this.noUserAlert = false;
    if (this.searchVals != "" && this.searchVals != null && this.searchVals != undefined) {
      this.visibleSearchInstructorTrainingPopup.close();
    } else {
      this.noUserAlert = true;
    }
  }
  cancelSearchInstructorTrainingFunction() {
    this.noUserAlert = false;
    this.searchByInstructorTrainingScheduleId = null;
    this.getSelectedInstructorTrainingName = '';
    this.visibleSearchInstructorTrainingPopup.close();
  }
  getUsersInstructorTraining() {
    if (this.showTrainerLevel) {
      let searchByInstructorTrainer1 = "";
      if (this.searchByInstructorTrainer.length) {
        for (let j = 0; j < this.searchByInstructorTrainer.length; j++) {
          searchByInstructorTrainer1 += this.searchByInstructorTrainer[j];
          searchByInstructorTrainer1 += j == this.searchByInstructorTrainer.length - 1 ? "" : ",";
        }
        this.newRun("inT", searchByInstructorTrainer1)
      } else {
        this.newRun("inT", "01010")
      }
      console.log("data", this.searchByReportCodeMain)
    } else if (this.getSelectedTrainingId) {
      this.newRun("in", this.getSelectedTrainingId)
      console.log("data12345", this.searchByReportCodeMain)
    } else if (this.searchByReportCodeMain) {
      this.newRun("in", "01010")
      console.log("datadata", this.searchByReportCodeMain)
    } else {
      const field = document.getElementById('manageReportNameAlert') as HTMLInputElement;
      field.style.color = 'red';
    }

  }
  //search training
  popupDataTitle: PopupData = {
    title: ''
  };
  trainingGroupTrainingFieldData: any = {};
  operationFlag: any;
  popupTitle: string | null = 'title';
  @ViewChild('searchTraining', { static: true }) searchTraining: TemplateRef<any>;
  visibleSearchTrainingPopup: MatDialogRef<TemplateRef<any>>;
  searchByTrainingName: any = null;
  searchByTrainingCode: any = null;
  searchByCategory: any = null;
  searchByLanguage: any = null;
  categoryValue: any;
  languageValue: any;
  searchTmsTrainingsVwDetails: any;
  getTmsTrainingDetailsTableData: any = [];
  searchTrainingConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };
  searchTrainingFunction() {
    this.multiUsersArray = [];
    this.showUserSearchGrid = false;
    this.searchByTrainingName = null;
    this.searchByTrainingCode = null;
    this.searchByCategory = null;
    this.searchByLanguage = null;
    this.popupDataTitle.title = "Search Training";
    this.visibleSearchTrainingPopup = this.dialog.open(this.searchTraining, this.searchTrainingConfig);
  }


  categoryDropdown: any = [];
  languageDropdown: any = [];
  selectBoxeForCategory() {
    this.dropDownForCategories.forEach((category: { trainingCategoryCode: any; trainingCategoryName: any; }) => {
      this.categoryDropdown = this.categoryDropdown.concat({
        valueExp: category.trainingCategoryCode,
        displayExp: category.trainingCategoryName
      });
    });
  }

  selectBoxeForLanguage() {
    this.dropDownForLangauge.forEach((language: { codelistCode: any; codelistName: any; }) => {
      this.languageDropdown = this.languageDropdown.concat({
        valueExp: language.codelistCode,
        displayExp: language.codelistName
      });
    });
  }
  selectedCategoryValue: any = null;
  selectedLanguageValue: any = null;
  selectedLevelValue: any;
  selectedTemplateValue: any;
  onCategorySelectNew(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.selectedCategoryValue = item;
      })
    }
  }
  onLangaugeSelectNew(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.selectedLanguageValue = item;
      })
    }
  }
  cancelSearchTrainingFunction() {
    this.getSelectedTrainingId = null;
    this.getSelectedTrainingName = '';
    this.getSelectedVersion = null;
    this.noUserAlert = false;
    this.visibleSearchTrainingPopup.close();
    this.searchUserParentCheckBox = false;
  }
  searchTrainingGridDataFunction() {
    this.searchUserParentCheckBox = false;
    this.isProcessing = true;
    if (this.searchByCategory) {
      this.categoryValue = this.searchByCategory;
    } else {
      this.categoryValue = null;
    }
    if (this.searchByLanguage) {
      this.languageValue = this.searchByLanguage;
    } else {
      this.languageValue = null;
    }
    this.searchTmsTrainingsVwDetails = {
      trainingName: this.searchByTrainingName,
      trainingCode: this.searchByTrainingCode,
      category: this.categoryValue,
      language: this.languageValue,
      groupId: null
    };
    this.appService.searchTrainingsByCondition(this.searchTmsTrainingsVwDetails).subscribe((response: any) => {
      this.getTmsTrainingDetailsTableData = response;
      this.showUserSearchGrid = true;
      this.isProcessing = false;
    })
  }

  resetSearchTrainingGridDataFunction() {
    this.isProcessing = true;
    this.searchByTrainingName = null;
    this.searchByTrainingCode = null;
    this.searchByCategory = null;
    this.searchByLanguage = null;
    this.getTmsTrainingDetailsTableData = [];
    this.showUserSearchGrid = false;
    this.pagedItemsMain = [];
    this.isProcessing = false;
  }
  getSelectedTrainingId: any;
  getSelectedTrainingName: string;
  getSelectedVersion: any;
  searchTrainingChildCheckBoxChecked(e: any, listOfTrainingsVwDetails: any, idx: any) {
    if (e.target.checked) {
      listOfTrainingsVwDetails.searchTrainingChildCheckBoxs = true;
      if (!this.multiUsersArray.some((storedUser: any) => storedUser.trainingId === listOfTrainingsVwDetails.trainingId)) {
        this.multiUsersArray.push({ trainingId: listOfTrainingsVwDetails.trainingId, trainingName: listOfTrainingsVwDetails.trainingName });
      }
      this.searchUserParentCheckBox = this.getTmsTrainingDetailsTableData.every((allUsers: any) => allUsers.searchTrainingChildCheckBoxs);
    } else {
      listOfTrainingsVwDetails.searchTrainingChildCheckBoxs = false;
      const removal = this.multiUsersArray.findIndex((storedUser: any) => storedUser.trainingId === listOfTrainingsVwDetails.trainingId);
      if (removal > -1) this.multiUsersArray.splice(removal, 1);
      this.searchUserParentCheckBox = this.getTmsTrainingDetailsTableData.every((allUsers: any) => allUsers.searchTrainingChildCheckBoxs);
    }
  }




  getTmsInstructorTrainerDataList: any;
  selectBoxeForTrainerValue() {
    this.getTmsInstructorTrainerDataList = [];
    console.log("getTmsInstructorTrainerData=", this.getTmsInstructorTrainerData)
    this.getTmsInstructorTrainerData.forEach((trainer: { trainerId: any; trainerName: any; }) => {
      this.getTmsInstructorTrainerDataList = this.getTmsInstructorTrainerDataList.concat({
        valueExp: trainer.trainerId,
        displayExp: trainer.trainerName
      });
    });
  }


  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;
  openFileDialog() {
    this.fileInput.nativeElement.click();
  }

  file: any;
  fileExtension: any;
  filename: any; retackTrainings() {
    if (!this.isAnyColumnSelected()) {
      alert("Please select at least one training before Re-Assign trainings.");
      return;
    }

    const blockedScheduledStatuses = new Set(['Scheduled', 'Deleted', 'Cancelled', 'Completed']);
    const unretakeableUserStatuses = new Set([
      "Pending", "In Progress", "Scheduled", "Failed", "Withdrawn",
      "Locked Overdue", "Permanently Locked", "Present", "Absent"
    ]);


    const ineligibleTrainings: string[] = [];

    for (const training of this.tmsUserTrainingsRepVwDataForGrid) {
      if (!training.isSelected) {
        continue;
      }

      const userStatus = training.USER_TRAINING_STATUS;
      const schedStatus = training.SCHEDULED_TRAINING_STATUS;
      const trainingInfo = training.TRAINING_NAME || training.USR_FULLNAME || 'Unknown';

      // 4. Case 1: Use .has() for the Set lookup
      if (unretakeableUserStatuses.has(userStatus)) {
        training.isSelected = false;
        ineligibleTrainings.push(`${trainingInfo} (User Status: ${userStatus})`);
        continue;
      }

      // 5. Case 2: User status is "Completed" → check scheduled status using .has()
      if (userStatus === "Completed" && blockedScheduledStatuses.has(schedStatus)) {
        training.isSelected = false;
        ineligibleTrainings.push(`${trainingInfo} (User: Completed, Scheduled: ${schedStatus})`);
      }
    }

    // Update selectAll checkbox
    this.selectAllChecked = this.tmsUserTrainingsRepVwDataForGrid.every((u: any) => u.isSelected);

    // Show alert if any were unselected
    if (ineligibleTrainings.length > 0) {
      const message = `The following training(s) cannot be retaken and have been unselected:\n${ineligibleTrainings.join('\n')}`;
      alert(message);
    }

    // Final check: is anything still selected?
    const hasAnyRetakeable = this.tmsUserTrainingsRepVwDataForGrid.some((t: any) => t.isSelected);
    if (!hasAnyRetakeable) {
      return;
    }

    // Open popup
    this.currentRetakeType = this.type;
    this.comments = "";
    this.duedate = null;
    this.popupVal = "retake";
    this.popupTitle = "Re-Assign Trainings";
    this.visibleretakePopup = this.dialog.open(this.retakeAndMarkasCompletedPopup, this.retakeAndMarkasCompletedPopupConfig);
  }

  removeUserTrining() {
    if (!this.isAnyColumnSelected()) {
      alert("Please select at least one training to proceed with withdrawal.");
      return;
    }
    const blockedScheduledStatuses = new Set(['Scheduled', 'Deleted', 'Cancelled', 'Completed']);
    const allowedUserStatuses = new Set([
      "Present", "Pending", "In Progress", "Failed",
      "Locked Overdue", "Permenantly Locked", "Locked", "Overdue"
    ]);

    let nonAllowedCounter = 0;
    const nonAllowedTrainings: string[] = [];

    for (const training of this.tmsUserTrainingsRepVwDataForGrid) {
      if (!training.isSelected) {
        continue;
      }

      const userStatus = training.USER_TRAINING_STATUS;
      const schedStatus = training.SCHEDULED_TRAINING_STATUS;
      const userName = training.USER_NAME;

      const isEligibleUserStatus = allowedUserStatuses.has(userStatus);
      const isEligibleSchedStatus = !blockedScheduledStatuses.has(schedStatus);
      if (training.TRAINING_TYPE == "Instructor led" || !isEligibleUserStatus || !isEligibleSchedStatus) {
        nonAllowedCounter++;
        const trainingInfo = training.TRAINING_NAME || training.USR_FULLNAME || 'Unknown';
        nonAllowedTrainings.push(`${trainingInfo} (User Name : ${userName},Status : ${userStatus}, Scheduled Status: ${schedStatus})`);
        training.isSelected = false;
      }
    }

    if (nonAllowedCounter > 0) {
      const message = nonAllowedCounter === 1
        ? `The following training cannot be withdrawn and has been unselected:\n${nonAllowedTrainings.join('\n')}`
        : `The following trainings cannot be withdrawn and have been unselected:\n${nonAllowedTrainings.join('\n')}`;

      alert(message);

      this.selectAllChecked = this.tmsUserTrainingsRepVwDataForGrid.every((t: any) => t.isSelected);

      if (!this.isAnyColumnSelected()) {
        return;
      }
    }

    this.file = null;
    this.filename = "";
    this.fileExtension = "";
    this.comments = "";
    this.duedate = null;
    this.popupVal = "withdrawn";
    this.popupTitle = "Withdraw";
    this.visibleretakePopup = this.dialog.open(this.retakeAndMarkasCompletedPopup, this.retakeAndMarkasCompletedPopupConfig);
  }
  retakeAndMarkasCompletedFunc() {
    if (!this.comments || this.comments.trim() === '') {
      alert("Please enter mandatory comments.");
      return;
    }
    const validateFields = () => {
      if (!this.duedate) {
        alert("Please enter a due date.");
        return false;
      }
      return true;
    };

    const handleApiResponse = (response: any) => {
      this.showSnackBar(response.result, response.resultType);
    };
    const processRetake = (training: any) => {
      console.log("training.USER_TRAINING_ID===", training.USER_TRAINING_ID);
      const data = {

        triningId: training.USER_TRAINING_ID,
        duedate: this.appService.dateZoneConvertion(new Date(this.duedate)),
        comments: this.comments,
        type: this.currentRetakeType
      };
      this.appService.retakeTraining(data).subscribe(handleApiResponse);
    };

    const processMarkAsCompleted = (training: any) => {
      const formData = new FormData();

      const trainingId = training.USER_TRAINING_ID.toString();
      formData.append('file', this.file ?? "");
      formData.append('extension', this.fileExtension ?? "");

      formData.append('trainingId', trainingId);
      formData.append('duedate', this.appService.dateZoneConvertion(new Date(this.duedate)));
      formData.append('comments', this.comments);
      this.appService.markAsCompletedTrainings(formData).subscribe(handleApiResponse);
    };
    const processRemove = (training: any) => {
      const formData = new FormData();

      const trainingId = training.USER_TRAINING_ID.toString();
      console.log("training.USER_TRAINING_ID===", training.USER_TRAINING_ID);

      formData.append('trainingId', trainingId);
      formData.append('comments', this.comments);
      this.appService.removeTrainings(formData).subscribe(handleApiResponse);
    };
    const refreshMainGrid = () => {
      // Only refresh the main grid based on the selected option
      if (this.selectedOption === 'Users') {
        if (this.chosenToUserId) {
          this.newRun("user", this.chosenToUserId.toString());
        } else {
          this.newRun("user", "01010");
        }
      } else if (this.selectedOption === 'Trainings') {
        if (this.getSelectedTrainingId) {
          this.newRun("tr", this.getSelectedTrainingId.toString());
        } else {
          this.newRun("tr", "01010");
        }
      } else if (this.selectedOption === 'Instructor Trainings') {
        if (this.showTrainerLevel) {
          let searchByInstructorTrainer1 = "";
          if (this.searchByInstructorTrainer.length) {
            for (let j = 0; j < this.searchByInstructorTrainer.length; j++) {
              searchByInstructorTrainer1 += this.searchByInstructorTrainer[j];
              searchByInstructorTrainer1 += j == this.searchByInstructorTrainer.length - 1 ? "" : ",";
            }
            this.newRun("inT", searchByInstructorTrainer1);
          } else {
            this.newRun("inT", "01010");
          }
        } else if (this.getSelectedTrainingId) {
          this.newRun("in", this.getSelectedTrainingId);
        } else {
          this.newRun("in", "01010");
        }
      }
      if (this.currentType && this.currentWhereVal) {
        this.detailsGridGetCall(this.currentType, null, this.currentWhereVal);
      }
    };

    if (this.popupVal === "withdrawn") {
      const allowedStatusesForCompletion = new Set([
        "Pending",
        "Present",
        "In Progress",
        "Scheduled",
        "Failed",
        "Locked Overdue",
        "Permenantly Locked",
        "Locked"
      ]);
      let processedCount = 0;
      this.tmsUserTrainingsRepVwDataForGrid.forEach((training: any, index: number) => {
        console.log("training=", training);
        if (training.isSelected && allowedStatusesForCompletion.has(training.USER_TRAINING_STATUS)) {
          processRemove(training);
          processedCount++;
        }
        if (index === this.tmsUserTrainingsRepVwDataForGrid.length - 1) {
          this.visibleretakePopup.close();
          // Refresh only main grid after API calls complete
          if (processedCount > 0) {
            setTimeout(() => {
              refreshMainGrid();
            }, 2000); // Give time for API calls to complete
          }
        }
      });

    } else if (this.popupVal === "retake") {
      if (!validateFields()) return;
      //  Process retake for completed, present, and absent trainings
      let processedCount = 0;
      this.tmsUserTrainingsRepVwDataForGrid.forEach((training: any, index: number) => {
        console.log("training=", training.isSelected);
        if (training.isSelected &&
          (training.USER_TRAINING_STATUS === "Completed" ||
            training.USER_TRAINING_STATUS === "Present" ||
            training.USER_TRAINING_STATUS === "Absent") && training.STATUS != "Withdrawn") {
          console.log(training);
          processRetake(training);
          processedCount++;
        } console.log("555", training);
        if (index === this.tmsUserTrainingsRepVwDataForGrid.length - 1) {
          this.visibleretakePopup.close();
          // Refresh only main grid after API calls complete
          if (processedCount > 0) {
            setTimeout(() => {
              refreshMainGrid();
            }, 2000); // Give time for API calls to complete
          }
        }
      });

    } else if (!validateFields() || !this.file) {
      console.log("7")
      alert("Please enter mandatory fields");
    } else if (this.markasCompletedBtndisable) {
      this.showSnackBar(this.markResult, this.resultType);
    } else {
      const allowedStatusesForCompletion = new Set([
        "Pending",
        "Present",
        "In Progress",
        "Scheduled",
        "Failed",
        "Locked Overdue",
        "Permenantly Locked",
        "Locked"
      ]); let processedCount = 0;
      this.tmsUserTrainingsRepVwDataForGrid.forEach((training: any, index: number) => {
        console.log("training=", training);
        if (training.isSelected && allowedStatusesForCompletion.has(training.USER_TRAINING_STATUS)) {
          processMarkAsCompleted(training);
          processedCount++;
        }
        if (index === this.tmsUserTrainingsRepVwDataForGrid.length - 1) {
          this.visibleretakePopup.close();
          // Refresh only main grid after API calls complete
          if (processedCount > 0) {
            setTimeout(() => {
              refreshMainGrid();
            }, 2000); // Give time for API calls to complete
          }
        }
      });
    }
    this.selectAllChecked = false;

  }
  cancelRetakeAndMarkasCompletedFunc() {
    this.visibleretakePopup.close();
  }
  cancelExportPopup() {
    this.visibleretakePopup.close();
  }
  showNotCompleted() {
    console.log("1" + this.notCompleted)
    if (this.notCompleted) {
      this.notCompleted = false;
      this.notCompleted = false;
      console.log("2" + this.notCompleted)
    } else {
      this.notCompleted = true;
      this.notCompleted = true;
      console.log("3" + this.notCompleted)
    }
    if (this.notCompleted) {
      this.chartList.push(
        { lable: "Pending", value: this.pendingVal, color: "yellow" },
        { lable: "Attempted", value: this.attemptedVal, color: "DodgerBlue" },
        { lable: "Inprogress", value: this.inprogressVal, color: "green" },
        { lable: "Completed", value: this.completedVal, color: "green" },
        { lable: "Failed", value: this.failedVal, color: "red" },
        { lable: "Withdrawn", value: this.withdrawnVal, color: "red" },
        { lable: "Scheduled", value: this.scheduledVal, color: "gray" },
        { lable: "Overdue", value: this.overdueVal, color: "green" },
        { lable: "locked", value: this.lockedVal, color: "green" }
      );
    } else {
      this.chartList.push(
        { lable: "Attempted", value: this.attemptedVal, color: "DodgerBlue" },
        { lable: "Yet To Be Attempted", value: this.yetToBeAttemptedVal, color: "yellow" },
        { lable: "Scheduled At Attempted Chart", value: this.scheduledAtAttemptedChartVal, color: "DodgerBlue" },
        { lable: "Failed At Attempted Chart", value: this.failedAtAttemptedChartVal, color: "red" },
        { lable: "Withdrawn At Attempted Chart", value: this.withdrawnAtAttemptedChartVal, color: "red" },
        { lable: "Completed At Attempted", value: this.completedAtAttemptedVal, color: "green" }
      );
    }

  }
  showTeamUserLevel(e: any) {
    if (e.target.checked) {
      this.teamUserLevel = true;
    } else {
      this.teamUserLevel = false;
    }
  }

  showGrouphTrainingLevel(e: any) {
    if (e.target.checked) {
      this.grouphTrainingLevel = true;
    } else {
      this.grouphTrainingLevel = false;
    }
  }

  showTrainerLevelFcn(e: any) {
    this.searchVals = null;
    if (e.target.checked) {
      this.showTrainerLevel = true;
    } else {
      this.showTrainerLevel = false;
    }
  }
  showDepartmentUserLevel(e: any) {
    if (e.target.checked) {
      this.departmentUserLevel = true;
    } else {
      this.departmentUserLevel = false;
    }
  }
  statusData = [{
    status: "Completed",
    trainingCount: 0,
    color: "#97C95C"
  }, {
    status: "Not Completed",
    trainingCount: 0,
    color: "#ebb434"
  }, {
    status: "Not Completed-Over Due",
    trainingCount: 0,
    color: "#F5564A"
  }];

  handleDropDownValidation(fieldId: string, selectedItems: any[] | string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isExcelPdf = ['execl-pdf'].includes(fieldId);
    const isNoSelection = selectedItems.length === 0;
    if (field) {
      if ((isExcelPdf && isNoSelection) || (!isExcelPdf && !selectedItems)) {
        field.style.color = 'red';
      } else {
        field.style.color = '#005c8a';
      }
    }
  }

  moreActivityReportDetails(val: any, pageVal: any) {
    this.service.tmsReportButtonVal = val;
    if (pageVal == 1) {
      this.selectedOption = val;
    } else {
      this.router.navigate(['/dashboard/tmsUserTrainingsReport']);
    }
    pageVal == 3 && this.router.navigate(['/dashboard/trainingsConclusiveTrail']);
    this.afterClickGenrate = false;
    this.ClickedSearchVal = "";
    this.ClickedStatusVal = "";
    this.searchByDepartmentCodeMain = [];
    this.totalVal = 0;
    this.attemptedVal = 0;
    this.yetToBeAttemptedVal = 0;
    this.completedAtAttemptedVal = 0;
    this.failedAtAttemptedChartVal = 0;
    this.withdrawnAtAttemptedChartVal = 0;
    this.scheduledAtAttemptedChartVal = 0;
    this.inprogressVal = 0;
    this.passedVal = 0;
    this.failedVal = 0;
    this.withdrawnVal = 0;
    this.scheduledVal = 0;
    this.lockedVal = 0;
    this.completedVal = 0;
    this.overdueVal = 0;
    this.pendingVal = 0;
    this.lockedOverdueVal = 0;
    this.tmsUserTrainingsRepVwDataForGrid = [];
    this.searchUserName = "";
    this.getSelectedTrainingName = "";
    this.childGridShow = false;
    this.notCompleted = false;
    this.teamUserLevel = false;
    this.departmentUserLevel = false;
    this.grouphTrainingLevel = false;
    this.instructorTrainingLevel = false;
    this.getOneQmsUsersTrainingsRepVwDetailsUserAndTraining = [];
    this.totalList = [];
    this.statusList = [];
    this.colorList = [];
    if (this.selectedOption == 'Instructor Trainings') {
      this.instructorTrainingLevel = true;
    }

  }
  colorList1: string[] = [
    '#F9F871',
    '#6B7887',
    '#00A6A9',
    '#BF83FF',
    '#005C8A',
    '#05004E',
    '#834160',
    '#9EADBD',
    '#BA7393',
    '#DEEBFE',
    '#96E480',
    '#839EFF',
    '#00A6A9',
    '#0081A5',
    '#291F1E',
    '#401F3E',
    '#C0DFA1',
    '#14342B',
    '#D0DB97',
    '#B07BAC',
    '#CF1259',
    '#E6B89C'
  ];
  colorMethod(val: any, iVal: any) {
    if (val == "Completed" || val == "Completed At Attempted") {
      return "#96E480";
    } else if (val == "Failed" || val == "Failed At Attempted Chart") {
      return "#EB5757";
    } else if (val == "Attempted") {
      return "#0081A5";
    } else if (val == "Scheduled" || val == "Scheduled At Attempted Chart") {
      return "#9EADBD";
    } else if (val == "Pending" || val == "Yet To Be Attempted") {
      return "#F9F871";
    } else {
      return this.colorList1[iVal];;
    }
  }
  reportListDropdown: any[];

  dropDownDataForReportLogo: any;
  selectedReportLogoValue: any = null;

  reportLogoDropdown: any = [];
  imageIdList: any = [];
  organizationReportImageDetails: any = {};
  logoVals: any; selectBoxForReportLogo() {
    this.reportLogoDropdown = [];

    if (this.dropDownDataForReportLogo) {
      const reportList = this.dropDownDataForReportLogo.reportImageList;

      // 1. Handle "Default" string case
      if (reportList === 'Default') {
        this.reportLogoDropdown.push({ valueExp: 0, displayExp: 'Default' });

        // 2. Handle Comma-Separated IDs
      } else if (reportList?.includes(",")) {
        this.imageIdList = reportList.split(",");

        // We use entries() to keep the 'i' index for your specific "i == 0" logic
        for (const [i, id] of this.imageIdList.entries()) {
          if (i === 0 && id === 'Default') {
            this.reportLogoDropdown.push({ valueExp: 0, displayExp: 'Default' });
          } else {
            for (const detail of this.organizationReportImageDetails) {
              if (detail.reportImageId == id) {
                this.reportLogoDropdown.push({
                  valueExp: detail.reportImageId,
                  displayExp: detail.reportImageName
                });
              }
            }
          }
        }

        // 3. Handle Single ID case
      } else {
        for (const detail of this.organizationReportImageDetails) {
          if (detail.reportImageId == reportList) {
            this.reportLogoDropdown.push({
              valueExp: detail.reportImageId,
              displayExp: detail.reportImageName
            });
          }
        }
      }

      // 4. Handle Selection Logic
      const defaultName = this.dropDownDataForReportLogo.defaultReportName;
      if (defaultName !== 'Default' && defaultName !== null) {
        for (const item of this.reportLogoDropdown) {
          if (item.valueExp == defaultName) {
            this.selectedReportLogoValue = item.valueExp;
          }
        }
      } else if (this.reportLogoDropdown.length > 0) {
        // Fallback to the first item found
        this.selectedReportLogoValue = this.reportLogoDropdown[0].valueExp;
      }

      this.reportLogoDropdown = [...this.reportLogoDropdown];

    } else {
      this.selectedReportLogoValue = [];
    }
  }
  onReportFooterSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportFooterFieldValidation != undefined) {
        this.reportFooterFieldValidation.style.color = '#005c8a';
      }
    }
  }

  ngOnChangesReportFooter() {
    this.isProcessing = true;
    this.appService.getCodeListsByGroup("REPORT_FOOTER").subscribe({
      next:
        (data: any) => {
          this.reportFooterDropdown1 = data;
          console.log("data", this.reportFooterDropdown1);

          this.selectBoxForFooter();
          if (this.reportFooterDropdown.length > 0) {
            this.selectedReportFooter = this.reportFooterDropdown[0].displayExp;
          }

          this.isProcessing = false;
        }, error:
        (error: any) => {
          this.isProcessing = false;
        }
    }
    );
  }

  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {
      if (vals.moduleList == "Common" || vals.moduleList.includes("TRN")) {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistName,
          displayExp: vals.codelistName
        });
        // }
      }
    }
  }
  ngOnInit() {
    this.message.showRetakeAndMarkasCompleted = true;
    this.reportListDropdown = [
      { valueExp: 1, displayExp: 'Users' },
      { valueExp: 5, displayExp: 'Trainings' },
      { valueExp: 7, displayExp: 'Instructor Trainings' }
    ];

    this.service.tmsReportButtonVal = 'Default';
    if (this.message.showRetakeAndMarkasCompleted) {
      this.selectedOption = 'Users';
    }
    this.selectedOption = this.selectedOption || 'Users';
    this.selectedOption = "Users";
    this.afterClickGenrate = false;
    this.ClickedSearchVal = "";
    this.ClickedStatusVal = "";
    this.searchByDepartmentCodeMain = [];
    this.totalVal = 0;
    this.attemptedVal = 0;
    this.yetToBeAttemptedVal = 0;
    this.completedAtAttemptedVal = 0;
    this.failedAtAttemptedChartVal = 0;
    this.withdrawnAtAttemptedChartVal = 0;
    this.scheduledAtAttemptedChartVal = 0;
    this.inprogressVal = 0;
    this.passedVal = 0;
    this.failedVal = 0;
    this.withdrawnVal = 0;
    this.scheduledVal = 0;
    this.lockedVal = 0;
    this.completedVal = 0;
    this.overdueVal = 0;
    this.pendingVal = 0;
    this.lockedOverdueVal = 0;
    this.tmsUserTrainingsRepVwDataForGrid = [];
    this.searchUserName = "";
    this.getSelectedTrainingName = "";
    this.childGridShow = false;
    this.notCompleted = false;
    this.teamUserLevel = false;
    this.departmentUserLevel = false;
    this.grouphTrainingLevel = false;
    this.instructorTrainingLevel = false;
    this.getOneQmsUsersTrainingsRepVwDetailsUserAndTraining = [];
    this.totalList = [];
    this.statusList = [];
    this.colorList = [];
    if (this.selectedOption == 'Instructor Trainings') {
      this.instructorTrainingLevel = true;
    }

    this.appService.getCategoriesList().subscribe((data: any) => {
      this.dropDownForCategories = data;
      this.selectBoxeForCategory();
    })
    this.appService.getCodeListsByGroup("TRAINING_LANGUAGE").subscribe((data: any) => {
      this.dropDownForLangauge = data;
      this.selectBoxeForLanguage();
    })

    this.appService.getInstructorTrainer().subscribe((response: any) => {
      this.getTmsInstructorTrainerData = response;
      this.selectBoxeForTrainerValue();
    })
    this.appService.getMainDashboardOrgList().subscribe((response: any) => {
      this.dropDownForOrg = response;
    })
    this.dropDownForDesignation = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') ?? '{}');
    this.dropDownForDepartment = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') ?? '{}');
    this.selectBoxForDepartment();
    this.selectBoxForDesignation();
    this.appService.getCodeListsByGroup('REPORT_DATE_RANGE').subscribe((data: any) => {
      this.dropDownForDateRange = data
      this.selectBoxForDateRange();
    })
    this.appService.getCodeListsByGroup('REPORT_INTERVAL').subscribe((data: any) => {
      this.dropDownForInterval = data
      this.selectBoxForInterval();
    })

    this.appService.getAllOrgReportImages().subscribe((response1: any) => {
      this.oneQmsOrgImagesDetails = response1;
    })

    this.appService.getOneQmsOrganization().subscribe((data: any) => {
      this.orgData = data;
    })

    this.appService.getTmsSettingsVwDetails().subscribe((response: any) => {
      if (response != null) {
        if (response.esignatureAtTrainingCompletion == "Y") {
          this.isEsignRequired = true;
        } else {
          this.isEsignRequired = false;
        }

        let data = {
          stageName: 'Completion',
          status: 'Complete',
          module: "TRN",
        }
        this.appService.getReasonForSigns(data).subscribe((data: any) => {
          if (data.length > 0) {
            this.reasonForSign = data[0].reasonForSignature;
          }

        })


      }
    })
    this.isProcessing = true;
    this.appService.getOneQmsOrganizationReportImage().subscribe({
      next: (data: any) => {
        this.organizationReportImageDetails = data;
        this.appService.getQmsReportLogoByModuleAndGroupId("TRN", 0).subscribe((data: any) => {
          this.dropDownDataForReportLogo = data;
          this.selectBoxForReportLogo();
          this.isProcessing = false;
        });
      }, error: (error: any) => {
        this.isProcessing = false;
      }
    })
    this.ngOnChangesReportFooter();
  }
  getDetails(obj: any, status: any) {
    obj = (this.perPage * this.pager.currentPage) - (this.perPage - obj);
    this.showOnlyConsider = false;
    this.searchByReson = null;
    this.showTrainingContents = false;
    this.pagedItemsSecond = [];
    this.getOneQmsUsersTrainingsRepVw = {};
    this.selectedStatus = "";
    console.log(obj);
    let whereVal = "";
    if (this.selectedOption == 'Users' || this.selectedOption == 'Team Member Trainings' || this.selectedOption == 'Organization') {
      this.selectedStatus = this.getOneQmsUsersTrainingsRepVwDetails[obj].usrFullname + "-" + this.statusVal(status);

      whereVal = " AND USER_ID='" + this.getOneQmsUsersTrainingsRepVwDetails[obj].userId + "'";
      console.log(whereVal, "==whereVal");
      if (status != "All") {
        if (status == "OVERDUE") {
          status = "(OVERDUE=1 OR LOCKED_OVERDUE";
          whereVal = whereVal + " AND " + status + "=1)";
        } else if (status == "LOCKED") {
          status = "(LOCKED=1 OR PERMENANTLY_LOCKED";
          whereVal = whereVal + " AND " + status + "=1)";
        } else {
          whereVal = whereVal + " AND " + status + "=1";
        }
      }
      this.detailsGridGetCall("user", "s", whereVal);
    } else if (this.selectedOption == 'Trainings') {
      this.selectedStatus = this.getOneQmsUsersTrainingsRepVwDetails[obj].trainingName + "-" + this.statusVal(status);
      whereVal = " AND TRAINING_NAME='" + this.getOneQmsUsersTrainingsRepVwDetails[obj].trainingName + "'";
      whereVal = whereVal + " AND VERSION=" + this.getOneQmsUsersTrainingsRepVwDetails[obj].version + "";
      if (status != "All") {
        if (status == "OVERDUE") {
          status = "(OVERDUE=1 OR LOCKED_OVERDUE";
          whereVal = whereVal + " AND " + status + "=1)";
        } else if (status == "LOCKED") {
          status = "(LOCKED=1 OR PERMENANTLY_LOCKED";
          whereVal = whereVal + " AND " + status + "=1)";
        } else {
          whereVal = whereVal + " AND " + status + "=1";
        }
      }
      this.detailsGridGetCall("user", "s", whereVal);
    } else if (this.selectedOption == 'Instructor Trainings') {
      if (this.showTrainerLevel) {
        let searchByInstructorTrainer1 = "";
        if (this.searchByInstructorTrainer.length) {
          for (let j = 0; j < this.searchByInstructorTrainer.length; j++) {
            searchByInstructorTrainer1 += this.searchByInstructorTrainer[j];
            searchByInstructorTrainer1 += j == this.searchByInstructorTrainer.length - 1 ? "" : ",";
          }
          this.selectedStatus = this.getOneQmsUsersTrainingsRepVwDetails[obj].trainingName + "-" + this.statusVal(status);
          console.log("searchByInstructorTrainer1=", searchByInstructorTrainer1)
          whereVal = " AND TRAINER_ID IN (" + searchByInstructorTrainer1 + ")";
          whereVal = whereVal + " AND TRAINING_NAME='" + this.getOneQmsUsersTrainingsRepVwDetails[obj].trainingName + "'";
          whereVal = whereVal + " AND VERSION=" + this.getOneQmsUsersTrainingsRepVwDetails[obj].version;

          if (status != "All") {
            if (status == "OVERDUE") {
              status = "(OVERDUE=1 OR LOCKED_OVERDUE";
              whereVal = whereVal + " AND " + status + "=1)";
            } else if (status == "LOCKED") {
              status = "(LOCKED=1 OR PERMENANTLY_LOCKED";
              whereVal = whereVal + " AND " + status + "=1)";
            } else {
              whereVal = whereVal + " AND " + status + "=1";
            }
          }
          console.log("whereVal=", whereVal)
          this.detailsGridGetCall("inT", "s", whereVal);
        } else {
          this.selectedStatus = this.getOneQmsUsersTrainingsRepVwDetails[obj].trainingName + "-" + this.statusVal(status);
          whereVal = " AND TRAINING_NAME='" + this.getOneQmsUsersTrainingsRepVwDetails[obj].trainingName + "'";
          whereVal = whereVal + " AND VERSION=" + this.getOneQmsUsersTrainingsRepVwDetails[obj].version;

          if (status != "All") {
            if (status == "OVERDUE") {
              status = "(OVERDUE=1 OR LOCKED_OVERDUE";
              whereVal = whereVal + " AND " + status + "=1)";
            } else if (status == "LOCKED") {
              status = "(LOCKED=1 OR PERMENANTLY_LOCKED";
              whereVal = whereVal + " AND " + status + "=1)";
            } else {
              whereVal = whereVal + " AND " + status + "=1";
            }
          }
          this.detailsGridGetCall("inT", "s", whereVal);
        }
      } else if (this.getSelectedTrainingId) {
        this.selectedStatus = this.getOneQmsUsersTrainingsRepVwDetails[obj].trainingName + "-" + status;

        whereVal = " AND TRAINING_SCHEDULE_ID IN (" + this.getSelectedTrainingId + ")";
        whereVal = whereVal + " AND TRAINING_NAME='" + this.getOneQmsUsersTrainingsRepVwDetails[obj].trainingName + "'";
        whereVal = whereVal + " AND VERSION=" + this.getOneQmsUsersTrainingsRepVwDetails[obj].version;

        if (status != "All") {
          if (status == "OVERDUE") {
            status = "(OVERDUE=1 OR LOCKED_OVERDUE";
            whereVal = whereVal + " AND " + status + "=1)";
          } else if (status == "LOCKED") {
            status = "(LOCKED=1 OR PERMENANTLY_LOCKED";
            whereVal = whereVal + " AND " + status + "=1)";
          } else {
            whereVal = whereVal + " AND " + status + "=1";
          }
        }
        this.detailsGridGetCall("inT", "s", whereVal);
      } else {
        this.selectedStatus = this.getOneQmsUsersTrainingsRepVwDetails[obj].trainingName + "-" + this.statusVal(status);
        whereVal = " AND TRAINING_NAME='" + this.getOneQmsUsersTrainingsRepVwDetails[obj].trainingName + "'";
        whereVal = whereVal + " AND VERSION=" + this.getOneQmsUsersTrainingsRepVwDetails[obj].version;

        if (status != "All") {
          if (status == "OVERDUE") {
            status = "(OVERDUE=1 OR LOCKED_OVERDUE";
            whereVal = whereVal + " AND " + status + "=1)";
          } else if (status == "LOCKED") {
            status = "(LOCKED=1 OR PERMENANTLY_LOCKED";
            whereVal = whereVal + " AND " + status + "=1)";
          } else {
            whereVal = whereVal + " AND " + status + "=1";
          }
        }
        this.detailsGridGetCall("inT", "s", whereVal);
      }

    }

  }

  overAllGetDetails(status: any) {
    this.pagedItemsSecond = [];
    this.getOneQmsUsersTrainingsRepVw = {};
    this.selectedStatus = "";
    this.showOnlyConsider = false;
    this.searchByReson = null;
    this.showTrainingContents = false;
    console.log("status=", status);
    let whereVal = "";
    if (this.selectedOption == 'Users') {
      if (this.chosenToUserId) {
        this.selectedStatus = this.statusVal(status);
        whereVal = " AND USER_ID IN (" + this.chosenToUserId + ")";
        if (status != "All") {
          if (status == "OVERDUE") {
            status = "(OVERDUE=1 OR LOCKED_OVERDUE";
            whereVal = whereVal + " AND " + status + "=1)";
          } else if (status == "LOCKED") {
            status = "(LOCKED=1 OR PERMENANTLY_LOCKED";
            whereVal = whereVal + " AND " + status + "=1)";
          } else {
            whereVal = whereVal + " AND " + status + "=1";
          }
        }
        this.detailsGridGetCall("user", "s", whereVal);
      } else {
        this.selectedStatus = this.statusVal(status);
        if (status == "All") {
          whereVal = "ORDER BY USR_FULLNAME ASC";
        } else if (status == "OVERDUE") {
          status = "(OVERDUE=1 OR LOCKED_OVERDUE";
          whereVal = whereVal + " AND " + status + "=1)";
        } else if (status == "LOCKED") {
          status = "(LOCKED=1 OR PERMENANTLY_LOCKED";
          whereVal = whereVal + " AND " + status + "=1)";
        } else {
          whereVal = whereVal + " AND " + status + "=1";
        }

        this.detailsGridGetCall("user", "s", whereVal);
      }
    } else if (this.selectedOption == 'Trainings') {
      if (this.getSelectedTrainingId) {
        this.selectedStatus = this.statusVal(status);
        whereVal = " AND TRAINING_ID IN (" + this.getSelectedTrainingId + ")";
        if (status != "All") {
          if (status == "OVERDUE") {
            status = "(OVERDUE=1 OR LOCKED_OVERDUE";
            whereVal = whereVal + " AND " + status + "=1)";
          } else if (status == "LOCKED") {
            status = "(LOCKED=1 OR PERMENANTLY_LOCKED";
            whereVal = whereVal + " AND " + status + "=1)";
          } else {
            whereVal = whereVal + " AND " + status + "=1";
          }
        }
        this.detailsGridGetCall("user", "s", whereVal);
      } else {
        this.selectedStatus = this.statusVal(status);
        if (status == "All") {
          whereVal = "ORDER BY TRAINING_NAME ASC";
        } else if (status == "OVERDUE") {
          status = "(OVERDUE=1 OR LOCKED_OVERDUE";
          whereVal = whereVal + " AND " + status + "=1)";
        } else if (status == "LOCKED") {
          status = "(LOCKED=1 OR PERMENANTLY_LOCKED";
          whereVal = whereVal + " AND " + status + "=1)";
        } else {
          whereVal = whereVal + " AND " + status + "=1";
        }

        this.detailsGridGetCall("user", "s", whereVal);
      }
    } else if (this.selectedOption == 'Instructor Trainings') {
      if (this.showTrainerLevel) {
        let searchByInstructorTrainer1 = "";
        if (this.searchByInstructorTrainer.length) {
          for (let j = 0; j < this.searchByInstructorTrainer.length; j++) {
            console.log("data for this", this.searchByInstructorTrainer);
            searchByInstructorTrainer1 += this.searchByInstructorTrainer[j];
            searchByInstructorTrainer1 += j == this.searchByInstructorTrainer.length - 1 ? "" : ",";
          }
          this.selectedStatus = this.statusVal(status);
          whereVal = " AND TRAINER_ID IN (" + searchByInstructorTrainer1 + ")";
          if (status != "All") {
            if (status == "OVERDUE") {
              status = "(OVERDUE=1 OR LOCKED_OVERDUE";
              whereVal = whereVal + " AND " + status + "=1)";
            } else if (status == "LOCKED") {
              status = "(LOCKED=1 OR PERMENANTLY_LOCKED";
              whereVal = whereVal + " AND " + status + "=1)";
            } else {
              whereVal = whereVal + " AND " + status + "=1";
            }
          }
          this.detailsGridGetCall("inT", "s", whereVal);
        } else {
          this.selectedStatus = this.statusVal(status);
          if (status == "All") {
            whereVal = whereVal + "ORDER BY TRAINING_NAME ASC";
          } else if (status == "OVERDUE") {
            status = "(OVERDUE=1 OR LOCKED_OVERDUE";
            whereVal = whereVal + " AND " + status + "=1)";
          } else if (status == "LOCKED") {
            status = "(LOCKED=1 OR PERMENANTLY_LOCKED";
            whereVal = whereVal + " AND " + status + "=1)";
          } else {
            whereVal = whereVal + " AND " + status + "=1";
          }

          this.detailsGridGetCall("inT", "s", whereVal);
        }
      } else if (this.getSelectedTrainingId) {
        this.selectedStatus = this.statusVal(status);
        whereVal = " AND TRAINING_SCHEDULE_ID IN (" + this.getSelectedTrainingId + ")";
        if (status != "All") {
          if (status == "OVERDUE") {
            status = "(OVERDUE=1 OR LOCKED_OVERDUE";
            whereVal = whereVal + " AND " + status + "=1)";
          } else if (status == "LOCKED") {
            status = "(LOCKED=1 OR PERMENANTLY_LOCKED";
            whereVal = whereVal + " AND " + status + "=1)";
          } else {
            whereVal = whereVal + " AND " + status + "=1";
          }
        }
        this.detailsGridGetCall("inT", "s", whereVal);
      } else {
        this.selectedStatus = this.statusVal(status);

        if (status == "All") {
          whereVal = whereVal + "ORDER BY TRAINING_NAME ASC";
        } else if (status == "OVERDUE") {
          status = "(OVERDUE=1 OR LOCKED_OVERDUE";
          whereVal = whereVal + " AND " + status + "=1)";
        } else if (status == "LOCKED") {
          status = "(LOCKED=1 OR PERMENANTLY_LOCKED";
          whereVal = whereVal + " AND " + status + "=1)";
        } else {
          whereVal = whereVal + " AND " + status + "=1";
        }

        this.detailsGridGetCall("inT", "s", whereVal);
      }

    }
  }
  isAnyColumnSelected(): boolean {
    return this.selectAllChecked || this.tmsUserTrainingsRepVwDataForGrid.some((item: { isSelected: any; }) => item.isSelected);
  }
  markAsCompleted() {
    if (!this.isAnyColumnSelected()) {
      alert("Please select at least one column before mark as completed.");
      return;
    }

    const blockedScheduledStatuses = new Set(['Scheduled', 'Deleted', 'Cancelled', 'Completed']);
    let nonAllowedCounter = 0;
    let nonAllowedTrainings: string[] = [];

    const allowedUserStatuses = new Set([
      "Present", "Pending", "In Progress", "Failed",
      "Locked Overdue", "Permenantly Locked", "Locked"
    ]);

    for (const training of this.tmsUserTrainingsRepVwDataForGrid) {
      if (!training.isSelected) {
        continue;
      }

      const userStatus = training.USER_TRAINING_STATUS;
      const schedStatus = training.SCHEDULED_TRAINING_STATUS;

      const isEligibleUserStatus = allowedUserStatuses.has(userStatus);

      const isEligibleSchedStatus = !blockedScheduledStatuses.has(schedStatus);

      if (!isEligibleUserStatus || !isEligibleSchedStatus) {
        nonAllowedCounter++;
        const trainingInfo = training.TRAINING_NAME || training.USR_FULLNAME || 'Unknown';
        nonAllowedTrainings.push(`${trainingInfo} (User: ${userStatus}, Scheduled: ${schedStatus})`);

        training.isSelected = false;
      }
    }

    if (nonAllowedCounter > 0) {
      const message = nonAllowedCounter === 1
        ? `The following training cannot be marked as completed and has been unselected:\n${nonAllowedTrainings.join('\n')}`
        : `The following trainings cannot be marked as completed and have been unselected:\n${nonAllowedTrainings.join('\n')}`;
      alert(message);
      this.selectAllChecked = this.tmsUserTrainingsRepVwDataForGrid.every((t: any) => t.isSelected);
      if (!this.isAnyColumnSelected()) return;
    }

    // Proceed to open popup
    this.file = null;
    this.filename = "";
    this.fileExtension = "";
    this.comments = "";
    this.duedate = null;
    this.popupVal = "mark";
    this.popupTitle = "Mark as Completed";
    this.visibleretakePopup = this.dialog.open(this.retakeAndMarkasCompletedPopup, this.retakeAndMarkasCompletedPopupConfig);
  }
  alertShown: boolean = false;
  selectAllChecked: boolean = false;
  selectAllRows() {
    let obsoletedTrainings: string[] = [];

    for (const user of this.tmsUserTrainingsRepVwDataForGrid) {
      // Only select non-obsoleted items
      if (user.REASON_FOR_NOT_CONSIDERED_AT_REPORT === 'Training Obsoleted') {
        user.isSelected = false; // Never select obsoleted trainings
        // Collect the training name or user info
        const trainingInfo = user.TRAINING_NAME || user.USR_FULLNAME || 'Unknown';
        obsoletedTrainings.push(trainingInfo);
      } else {
        user.isSelected = this.selectAllChecked;
      }
    }

    // Show single alert with all obsoleted trainings if any exist and selectAll is checked
    if (this.selectAllChecked && obsoletedTrainings.length > 0) {
      const message = `The following trainings are in obsoleted status and cannot be selected:\n\n${obsoletedTrainings.join('\n')}`;
      alert(message);
    }
  }
  // childCheckboxChanged() {
  //   this.selectAllChecked = this.tmsUserTrainingsRepVwDataForGrid.every((user: any) => user.isSelected);
  // }
  childCheckboxChanged() {
    // Use setTimeout to ensure the checkbox state is updated
    setTimeout(() => {
      // Check all items and unselect any obsoleted trainings that are selected
      this.tmsUserTrainingsRepVwDataForGrid = this.tmsUserTrainingsRepVwDataForGrid.map((item: any) => {
        if (item.REASON_FOR_NOT_CONSIDERED_AT_REPORT === 'Training Obsoleted' && item.isSelected) {
          item.isSelected = false;
          // Show alert only once
          if (!this.alertShown) {
            this.alertShown = true;
            alert("Cannot select obsoleted training");
            setTimeout(() => { this.alertShown = false; }, 100);
          }
        }
        console.log("item=", item);
        return item;
      });

      // Update selectAllChecked based on non-obsoleted items
      const nonObsoletedItems = this.tmsUserTrainingsRepVwDataForGrid
        .filter((user: any) => user.REASON_FOR_NOT_CONSIDERED_AT_REPORT !== 'Training Obsoleted');

      this.selectAllChecked = nonObsoletedItems.length > 0 &&
        nonObsoletedItems.every((user: any) => user.isSelected);
    }, 0);
  }
  detailsGridGetCall(type: any, val: any, whereVal: any) {

    this.currentType = type;
    this.currentWhereVal = whereVal;
    this.isProcessing = true;
    this.tmsUserTrainingsRepVwDataForGrid = [];
    const data = {

      gridName: "TMS_REPORTS",
      groupId: null
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {

        response.orderByClause ??= "";
        this.makeStickyColumns = response.fixedFieldCnt;
        let data1: any;
        data1 = {

          gridName: "TMS_REPORTS",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          selectedUserId: null,
          selectedFolderPath: null,
          selectedDocumentTypeName: null,
          selectedDocContainer: null,
          manualEntryDataFields: "DUE_DATE" + response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || "",
          reModule: this.selectedOption == 'Training Groups' ? "tmsGr" : "tms",
          wherVal: whereVal,
          isConsider: this.message.showRetakeAndMarkasCompleted ? "" : "Y"
        }

        this.appService.usergridddynamicDataForTmsReport(data1).subscribe({
          next: (response1: any) => {
            this.isProcessing = false;
            this.tmsUserTrainingsRepVwDataForGrid = response1;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            let rendereddata: any;
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const fieldSize of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(fieldSize + 'px');
            }
            for (let y = this.columnLists.columnsListarray.length - 1; y >= 0; y--) {
              if (this.columnLists.invisibleColumnarray.includes(this.columnLists.columnsListarray[y])) {
                this.columnLists.columnsListarray.splice(y, 1);
                this.columnLists.fieldColumnarray.splice(y, 1);
                this.columnLists.fieldSizeListArray.splice(y, 1);
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const dataType of this.dataTypeList) {
                  if (dataType.columnName === this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = dataType.fieldType;
                  }
                }
              }
              for (const record of this.tmsUserTrainingsRepVwDataForGrid) {
                for (const dataType of this.dataTypeList) {
                  if (dataType.fieldType === 'CHECKBOX') {
                    record[dataType.columnName] = record[dataType.columnName] === "Y";
                  }
                }
              }
              this.calculateTotalPagesSecond = this.collectionSizeSecond / this.perPageSecond;
              this.pagerSecond.totalPages = undefined;
              this.setPageSecond(1, 0);
            });
            this.message.gridList = this.tmsUserTrainingsRepVwDataForGrid;
            this.collectionSizeSecond = this.tmsUserTrainingsRepVwDataForGrid.length;
            this.totalPagesSecond = Math.ceil(this.tmsUserTrainingsRepVwDataForGrid.length / this.itemsPerPageSecond);
          }, error: (error: any) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });

    this.typeValForflag = type;
    this.whereValsForExcelTemp = "";
    this.whereValsForExcelTemp = whereVal;
    console.log("this.whereValsForExcelTemp=", this.whereValsForExcelTemp);

  }
  setPageSecond(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPagesSecond) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pagerSecond = this.paginationService.getPager(this.tmsUserTrainingsRepVwDataForGrid.length, page, this.perPageSecond, targetpage);
    this.pagedItemsSecond = this.tmsUserTrainingsRepVwDataForGrid.slice(this.pagerSecond.startIndex, this.pagerSecond.endIndex + 1);
    this.dropdownforResonfornotconsiderreport(this.tmsUserTrainingsRepVwDataForGrid);
  }
  setPageSecond1(page: number, targetpage: number) {
    console.log(this.pagedItemsSecond)
    if (page < 1 || page > this.pager.totalPagesSecond) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pagerSecond = this.paginationService.getPager(this.pagedItemsSecond1.length, page, this.perPageSecond, targetpage);
    console.log(this.pagedItemsSecond1)
    if (this.pagedItemsSecond1.length > 0) {
      this.pagedItemsSecond = this.pagedItemsSecond1.slice(this.pagerSecond.startIndex, this.pagerSecond.endIndex + 1);
    }
    console.log(this.pagedItemsSecond)
    this.dropdownforResonfornotconsiderreport(this.tmsUserTrainingsRepVwDataForGrid);
  }


  resonForNotConsiderDropdown: any[];

  dropdownforResonfornotconsiderreport(val: any) {
    console.log("val=", val);
    const reasons = [...new Set(
      val
        .map((x: any) => x.REASON_FOR_NOT_CONSIDERED_AT_REPORT)
        .filter((r: any) => r && r.trim() !== "") // ignore null/blank if needed
    )];

    this.resonForNotConsiderDropdown = reasons.map(r => ({
      valueExp: r,
      displayExp: r
    }));
    console.log("this.resonForNotConsiderDropdown===", this.resonForNotConsiderDropdown)
  }
  paginationCallSecond(value: number) {
    this.perPageSecond = value;
    this.setPageSecond(this.pagerSecond.currentPage, 0);
  }
  //Excell & PDF
  whereValsForExcel: any;
  whereValsForExcelTemp: any;
  typeValForflag: any;
  tempOrgIdForFlag: any;
  cancelReportPopup() {
    this.visibleExcelPdfPopup.close();
    this.manuallyPicked = false;
    this.selectedColumns = "";
  }
  selectedColumns: any;
  columnList: any;
  dropDownForPdfColumn: any;
  isForExcel: boolean = false;
  @ViewChild('excelPdfPopup', { static: true }) excelPdfPopup: TemplateRef<any>;
  excelPdfPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  }
  @ViewChild('excelPdfPopupOrgMain', { static: true }) excelPdfPopupOrgMain: TemplateRef<any>;
  excelPdfPopupOrgMainConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  }
  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;
  reportObj: any = {};
  pdfDetailSearchText: string = '';
  templateid: number;
  reportTemplateFieldValidation: any;
  reportLogoFieldValidation: any;
  onReportLogoValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.templateid = item;
      if (this.reportLogoFieldValidation != undefined) {
        this.reportLogoFieldValidation.style.color = '#005c8a';
      }

    }
  }
  reportName: any;
  isSaveReport: boolean = false;
  generateReport(value: any) {
    if (value == 'Pdf' && this.manuallyPicked && !this.selectedColumns.length) {
      this.showSnackBar('Please select the Columns', 'E');
    } else {
      this.appService.isProcessingRep = true;
      let colList = "";
      let fieldList = "";
      let mod = "";
      this.whereValsForExcel = "";
      console.log("this.whereValsForExcelTemp=", this.whereValsForExcelTemp);
      const data2 = {

        gridName: "TMS_REPORTS",
        groupId: null
      }
      this.appService.getDynamicGridHeaders(data2).subscribe({
        next: (response: any) => {


          console.log("this.showOnlyConsider", this.showOnlyConsider);
          let conForReport = "";

          if (this.message.showRetakeAndMarkasCompleted) {
            conForReport = this.showOnlyConsider ? " AND CONSIDERED_FOR_REPORT='N'" : "";
          } else if (this.searchByReson) {
            conForReport = ` AND CONSIDERED_FOR_REPORT='Y' AND REASON_FOR_NOT_CONSIDERED_AT_REPORT='${this.searchByReson}'`;
          } else {
            conForReport = " AND CONSIDERED_FOR_REPORT='Y'";
          }

          const orgId = this.message.getOrgId();

          if (this.whereValsForExcelTemp === "noStatus") {
            this.whereValsForExcel = ` WHERE ORG_ID=${orgId}${conForReport}`;
          } else {
            this.whereValsForExcel = ` WHERE ORG_ID=${orgId}${conForReport}${this.whereValsForExcelTemp}`;
          }
          mod = "tms";

          this.columnList = response.fieldLabelsList;
          const data = {

            groupId: this.qmsservice.selectedGroup
          }

          const data1: any = {

            tableOrViewName: response.tableOrViewName ?? "",
            columnsList: response.columnsList ?? "",
            fieldLabelsList: response.fieldLabelsList ?? "",
            invisibleColumn: response.invisibleColumn ?? "",
            orderByClause: response.orderByClause ?? "",
            fieldSizeList: response.fieldSizeList ?? "",
            columnsListarray: [],
            fieldColumnarray: [],
            invisibleColumnarray: [],
            fieldSizeListArray: [],
            status: this.statusCodeValue,
            codelistGroup: null,
            manualEntryDataFields: "DUE_DATE",
            groupId: this.qmsservice.selectedActivityGroupId,
            chartStatus: null,
            wherVal: this.whereValsForExcel,
            reModule: mod,
            logoId: this.selectedReportLogoValue ?? 0,
            isSaveRep: this.isSaveReport ? 'Y' : 'N',
            module: "TRN",
            reportName: this.reportName ?? "Report",
            currentStatus: "NA",
            groupName: "",
          }
          this.reportObj = { ...data1, ...data };
          debugger;
          if (value == 'Excel') {
            const pdfData = {
              ...this.reportObj, "footer": this.selectedReportFooter, title: this.selectedOption + "-" + this.selectedStatus, columns: [],
              "informationTab": {
                "Report Name": this.selectedOption,
                "Exported By": localStorage.getItem("loggedUserName")
              }
            }
            this.appService.downloadexcelForChart(pdfData, "Report.xlsx");
          } else {
            const pdfData = {
              ...this.reportObj, "footer": this.selectedReportFooter, title: this.selectedOption + "-" + this.selectedStatus, columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnList.split(',').slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
            }
            this.appService.downloadPdfForChart(pdfData, this.selectedOption + "_Report.pdf");
          }
        }, error: (error: any) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }
  openReportPopup(item: any) {
    this.excelPdf.dropDown = this.columnLists.fieldColumnarray.map((column: any) => ({ valueExp: column.fieldColumnarray, displayExp: column.fieldColumnarray }));

    this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') ?? '{}');
    this.excelPdf.pdfPageSize = 'A4';
    this.isForExcel = item == 'Excel';
    this.popupDataTitle.title = item == 'Excel' ? 'Excel Report' : 'PDF Report';
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    this.pdfSelection = false;
    const firstst = this.message.breadcrumbData.firstLevel;
    const secondnd = this.message.breadcrumbData.secondLevel;
    const thirdL = this.message.breadcrumbData.thirdLevel;
    const fourthL = this.message.breadcrumbData.fourthLevel;
    let fileName = "";
    if (firstst != null) {
      fileName = firstst + "_";
    }
    if (secondnd != null) {
      fileName = fileName + secondnd + "_";
    }
    if (thirdL != null) {
      fileName = fileName + thirdL + "_";
    }
    if (fourthL != null) {
      fileName = fileName + fourthL + "_";
    }
    this.reportName = fileName + Date.now();
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup, this.excelPdfPopupConfig);
    this.isSaveReport = false;
  }
  popupFlg: any;
  openReportPopupOrgMain(ty: any) {
    this.popupFlg = ty;
    this.popupDataTitle.title = 'Excel Report';
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopupOrgMain, this.excelPdfPopupOrgMainConfig);
    this.isSaveReport = false;
  }
  manuallyPicked: boolean;
  maxCountReached: boolean = false;
  selectedColumnsAsString: string = "";
  pdfPageSizes: any = [];
  @Input() excelPdf: any = {};
  onSelect() {
    if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
    this.convertArrayToString(this.selectedColumns);
  }
  @ViewChild('pdf') pdf: MatSelect;
  pdfSelection = false;

  @ViewChild('columns') columns: MatSelect;
  isAllColumns = false;

  convertArrayToString(array: any) {
    this.selectedColumnsAsString = array.join(', ');
    console.log("Method", this.selectedColumnsAsString);
  }
  toggleAllSelection(value: any) {
    if (value == 'pdf') {
      if (this.pdfSelection) this.pdf.options.forEach((item: MatOption) => item.select());
      else {
        this.pdf.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        this.handleDropDownValidation('execl-pdf', this.selectedColumns)
        this.convertArrayToString(this.selectedColumns);
      });
    } else if (value == 'columns') {
      if (this.isAllColumns) this.columns.options.forEach((item: MatOption) => item.select());
      else {
        this.columns.options.forEach((item: MatOption) => item.deselect())
        this.selectedColumns = [];
      }
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
      });
    }
    console.log("pdf", this.selectedColumns)
  }
  onCheckboxChange(event: MatSlideToggleChange) {
    if (!event.checked) {
      [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    }
  }
  onReportTypeSelectnew(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('manageReportNameAlert', item)
      if (item) {
        console.log(item)
        this.pagedItems7 = [];
        this.pagedItems2 = [];
        this.afterClickGenrate = false;
        this.ClickedSearchVal = "";
        this.ClickedStatusVal = "";
        this.searchByDepartmentCodeMain = [];
        this.totalVal = 0;
        this.attemptedVal = 0;
        this.yetToBeAttemptedVal = 0;
        this.completedAtAttemptedVal = 0;
        this.failedAtAttemptedChartVal = 0;
        this.withdrawnAtAttemptedChartVal = 0;
        this.scheduledAtAttemptedChartVal = 0;
        this.inprogressVal = 0;
        this.passedVal = 0;
        this.failedVal = 0;
        this.withdrawnVal = 0;
        this.scheduledVal = 0;
        this.lockedVal = 0;
        this.completedVal = 0;
        this.overdueVal = 0;
        this.pendingVal = 0;
        this.lockedOverdueVal = 0;
        this.tmsUserTrainingsRepVwDataForGrid = [];
        this.searchUserName = "";
        this.chosenToUserId = "";
        this.chosenToUserName = "";
        this.getSelectedTrainingName = "";
        this.childGridShow = false;
        this.notCompleted = false;
        this.teamUserLevel = false;
        this.departmentUserLevel = false;
        this.grouphTrainingLevel = false;
        this.instructorTrainingLevel = false;
        this.getOneQmsUsersTrainingsRepVwDetailsUserAndTraining = [];
        this.totalList = [];
        this.statusList = [];
        this.colorList = [];
        this.selectedStatus = "";
        this.specificIntervalVal = false;
        this.selectedTrainingCategory = "";
        this.selectedOverDue = "";
        this.getSelectedInstructorTrainingName = "";
        this.searchByInstructorTrainer = [];
        this.pagedItems = [];
        this.pagedItemsSecond = [];
        this.getOneQmsUsersTrainingsRepVw = {};
        this.tmsUserTrainingsRepVwDataForGrid = {};
        this.searchValue = "";
        this.selectedOption = item.displayExp

        this.resetFunction();
      }
    }
  }
  onReportTypeDeSelect(item: any) {
    this.handleDropDownValidation('manageReportNameAlert', this.searchByReportCodeMain)
  }
  onColumnSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        if (this.selectedColumns.length > 10) this.maxCountReached = true; else this.maxCountReached = false;
        this.convertArrayToString(this.selectedColumns);
        this.pdfSelection = this.selectedColumns.length == this.excelPdf.dropDown.length;
      });
    }
  }
  //end excell & pdf
  //main grid download


  excelDownloadMaingrid() {

    let considerForReportFlag = "";
    let attaptedVal = "";
    let typeVal = "";
    let vals = "";
    if (this.message.showRetakeAndMarkasCompleted) {
      considerForReportFlag = "noNeedConsiderForReport"
    } else {
      considerForReportFlag = "NeedConsiderForReport"
    }
    if (this.notCompleted) {
      attaptedVal = "att"
    } else {
      attaptedVal = "notatt"
    }
    let tname = "";
    let colList = "";
    let fieldList = "";
    this.whereValsForExcel = "";
    tname = "TMS_USER_TRAININGS_REP_CNT_VW";
    if (this.selectedOption == 'Users') {
      typeVal = "user";
      vals = this.searchUserId ? this.chosenToUserId.toString() : '01010';
      if (this.notCompleted) {
        colList = "USR_FULLNAME,TOTAL,PENDING,COMPLETED,FAILED,WITHDRAWN,SCHEDULED,INPROGRESS,OVERDUE,LOCKED,FAILED_ATTEMPTS,PASS,USER_ID";
        fieldList = "User Fullname,Total,Pending,Completed,Failed,Withdrawn,Scheduled,Inprogress,Overdue,Locked,Failed Attempts,Pass %,User ID";
      } else {
        colList = "USR_FULLNAME,TOTAL,YET_TO_BE_ATTEMPTED,ATTEMPTED,COMPLETED_AT_ATTEMPTED_CHART,FAILED_AT_ATTEMPTED_CHART,WITHDRAWN_AT_ATTEMPTED_CHART,SCHEDULED_AT_ATTEMPTED_CHART,FAILED_ATTEMPTS,PASS,USER_ID";
        fieldList = "User Fullname,Total,Yet To Be Attempted,Attempted,Completed,Failed,Withdrawn,Scheduled,Failed Attempts,Pass %,User ID";
      }
    } else if (this.selectedOption == 'Trainings') {
      typeVal = "tr";
      vals = this.getSelectedTrainingId ? this.getSelectedTrainingId.toString() : '01010';
      if (this.notCompleted) {
        colList = "TRAINING_NAME,VERSION,TOTAL,PENDING,COMPLETED,FAILED,WITHDRAWN,SCHEDULED,INPROGRESS,OVERDUE,LOCKED,FAILED_ATTEMPTS,PASS";
        fieldList = "Training Name,Version,Total,Pending,Completed,Failed,Withdrawn,Scheduled,Inprogress,Overdue,Locked,Failed Attempts,Pass %";
      } else {
        colList = "TRAINING_NAME,VERSION,TOTAL,YET_TO_BE_ATTEMPTED,ATTEMPTED,COMPLETED_AT_ATTEMPTED_CHART,FAILED_AT_ATTEMPTED_CHART,WITHDRAWN_AT_ATTEMPTED_CHART,SCHEDULED_AT_ATTEMPTED_CHART,FAILED_ATTEMPTS,PASS";
        fieldList = "Training Name,Version,Total,Yet To Be Attempted,Attempted,Completed,Failed,Withdrawn,Scheduled,Failed Attempts,Pass %";
      }
    } else if (this.selectedOption == 'Instructor Trainings') {
      if (this.showTrainerLevel) {
        let searchByInstructorTrainer1 = "";
        for (let j = 0; j < this.searchByInstructorTrainer.length; j++) {
          searchByInstructorTrainer1 += this.searchByInstructorTrainer[j];
          searchByInstructorTrainer1 += j == this.searchByInstructorTrainer.length - 1 ? "" : ",";
        }
        typeVal = "inT";
        vals = this.searchByInstructorTrainer.length ? searchByInstructorTrainer1 : '01010';
      } else {
        typeVal = "in";
        vals = this.getSelectedTrainingId ? this.getSelectedTrainingId : '01010';
      }
      if (this.notCompleted) {
        colList = "TRAINING_NAME,VERSION,TOTAL,PENDING,COMPLETED,FAILED,WITHDRAWN,SCHEDULED,INPROGRESS,OVERDUE,LOCKED,FAILED_ATTEMPTS,PASS";
        fieldList = "Training Name,Version,Total,Pending,Completed,Failed,Withdrawn,Scheduled,Inprogress,Overdue,Locked,Failed Attempts,Pass %";
      } else {
        colList = "TRAINING_NAME,VERSION,TOTAL,YET_TO_BE_ATTEMPTED,ATTEMPTED,COMPLETED_AT_ATTEMPTED_CHART,FAILED_AT_ATTEMPTED_CHART,WITHDRAWN,SCHEDULED_AT_ATTEMPTED_CHART,FAILED_ATTEMPTS,PASS";
        fieldList = "Training Name,Version,Total,Yet To Be Attempted,Attempted,Completed,Failed,Withdrawn,Scheduled,Scheduled At Attempted Chart,Failed Attempts,Pass %";
      }

    }
    this.whereValsForExcel = "";
    const data = {

      groupId: this.qmsservice.selectedGroup,
      type: typeVal,
      val: vals,
      attaptedVal: attaptedVal,
      considerForReportFlag: considerForReportFlag
    }
    const data1: any = {

      tableOrViewName: tname,
      columnsList: colList,
      fieldLabelsList: fieldList,
      invisibleColumn: "",
      orderByClause: "",
      fieldSizeList: "",
      columnsListarray: [],
      fieldColumnarray: [],
      invisibleColumnarray: [],
      fieldSizeListArray: [],
      status: this.statusCodeValue,
      codelistGroup: null,
      manualEntryDataFields: null,
      groupId: this.qmsservice.selectedActivityGroupId,
      chartStatus: null,
      wherVal: this.whereValsForExcel,
      reModule: "tms"
    }

    this.reportObj = { ...data1, ...data };
    debugger;
    const pdfData = {
      ...this.reportObj, "footer": this.selectedReportFooter, title: this.selectedOption + "-" + this.selectedStatus, columns: [],
      "informationTab": {
        "Report Name": this.selectedOption,
        "Exported By": localStorage.getItem("loggedUserName")
      }
    }
    this.appService.downloadexcelForMainGrid(pdfData, this.selectedOption + ".xlsx");

  }
  excelDownload(value: any) {
    console.log("this.whereValsForExcelTemp=" + this.whereValsForExcelTemp);
    let tname = "";
    let colList = "";
    let fieldList = "";
    this.whereValsForExcel = "";
    tname = "TMS_USER_TRAININGS_REP_CNT_VW";
    if (this.showTrainingContents) {
      colList = "USER_NAME,USR_FULLNAME,TRAINING_NAME,TRAINING_LEVEL,VERSION,TRAINING_CODE,TRAINING_TYPE,TRAINING_CONTENTS,GROUP_NAME,STATUS,IS_USER_ACTIVE,DESIGNATION_CODE,DEPARTMENT_CODE,MANAGER_FULLNAME,TRAINER_NAME,USER_TRAINING_STATUS,SCHEDULED_TRAINING_STATUS,EXPIRY_DATE,DUE_DATE,TRAINING_ASSIGNED_ON,INTIMATION_SENT_ON,STARTED_ON,COMPLETED_ON,INITIAL_ASSIGNED_ON,INITIAL_COMPLETED_ON,INITIAL_DUE_DATE,INITIAL_STARTED_ON,REMINDER_SENT_ON,ESCALATION_SENT_ON,LOCKED_ON,FAILED_LOCK_RM_APPROVED_ON,OVERDUE_LOCK_QA_APPROVED_ON,OVERDUE_LOCK_RM_APPROVED_ON,START_DATE,END_DATE,COMMENTS,FAILED_ATTEMPTS,FINAL_SCORE";
      fieldList = "User Name,User Fullname,Training Name,Training Level,Version,Training Code,Training Type,Training Contents,Group Name,Status,Is User Active,Designation Code,Department Code,Manager Fullname,Trainer Name,User Training Status,Scheduled Training Status,Expiry Date,Due Date,Training Assigned On,Intimation Sent On,Started On,Completed On,Initial Assigned On,Initial Completed On,Initial Due Date,Initial Started On,Reminder Sent On,Escalation Sent On,Locked On,Failed Lock Rm Approved On,Overdue Lock Qa Approved On,Overdue Lock Rm Approved On,Start Date,End Date,Comments,Failed Attempts,Final Score";
    } else {
      colList = "USER_NAME,USR_FULLNAME,TRAINING_NAME,TRAINING_LEVEL,VERSION,TRAINING_CODE,TRAINING_TYPE,GROUP_NAME,STATUS,IS_USER_ACTIVE,DESIGNATION_CODE,DEPARTMENT_CODE,MANAGER_FULLNAME,TRAINER_NAME,USER_TRAINING_STATUS,SCHEDULED_TRAINING_STATUS,EXPIRY_DATE,DUE_DATE,TRAINING_ASSIGNED_ON,INTIMATION_SENT_ON,STARTED_ON,COMPLETED_ON,INITIAL_ASSIGNED_ON,INITIAL_COMPLETED_ON,INITIAL_DUE_DATE,INITIAL_STARTED_ON,REMINDER_SENT_ON,ESCALATION_SENT_ON,LOCKED_ON,FAILED_LOCK_RM_APPROVED_ON,OVERDUE_LOCK_QA_APPROVED_ON,OVERDUE_LOCK_RM_APPROVED_ON,START_DATE,END_DATE,COMMENTS,FAILED_ATTEMPTS,FINAL_SCORE";
      fieldList = "User Name,User Fullname,Training Name,Training Level,Version,Training Code,Training Type,Group Name,Status,Is User Active,Designation Code,Department Code,Manager Fullname,Trainer Name,User Training Status,Scheduled Training Status,Expiry Date,Due Date,Training Assigned On,Intimation Sent On,Started On,Completed On,Initial Assigned On,Initial Completed On,Initial Due Date,Initial Started On,Reminder Sent On,Escalation Sent On,Locked On,Failed Lock Rm Approved On,Overdue Lock Qa Approved On,Overdue Lock Rm Approved On,Start Date,End Date,Comments,Failed Attempts,Final Score";
    }
    this.whereValsForExcel = " WHERE ORG_ID=" + this.message.getOrgId() + " AND CONSIDERED_FOR_REPORT='Y'" + this.whereValsForExcelTemp;
    const data = {

      groupId: this.qmsservice.selectedGroup
    }
    const data1: any = {

      tableOrViewName: tname,
      columnsList: colList,
      fieldLabelsList: fieldList,
      invisibleColumn: "",
      orderByClause: "",
      fieldSizeList: "",
      columnsListarray: [],
      fieldColumnarray: [],
      invisibleColumnarray: [],
      fieldSizeListArray: [],
      status: this.statusCodeValue,
      codelistGroup: null,
      manualEntryDataFields: null,
      groupId: this.qmsservice.selectedActivityGroupId,
      chartStatus: null,
      wherVal: this.whereValsForExcel,
      reModule: "tms"
    }
    this.reportObj = { ...data1, ...data };
    debugger;
    if (value == 'Excel') {
      const pdfData = {
        ...this.reportObj, title: this.selectedOption + "-" + this.selectedStatus, columns: [],
        "informationTab": {
          "Report Name": this.selectedOption,
          "Exported By": localStorage.getItem("loggedUserName")
        }
      }
      this.appService.downloadexcelForChart(pdfData, "Report.xlsx");
    } else {
      const pdfData = {
        ...this.reportObj, "footer": this.selectedReportFooter, title: this.selectedOption + "-" + this.selectedStatus, columns: this.manuallyPicked ? this.selectedColumns.join(',') : this.columnList.split(',').slice(0, 10).join(','), pdfPageSize: this.excelPdf.pdfPageSize
      }
      this.appService.downloadPdfForChart(pdfData, this.selectedOption + "_Report.pdf");
    }
  }
  //main grid excel download
  //evi start
  eviDownload(value: any) {
    this.isProcessing = true;
    let v1 = value['EVIDENCE_DOC_ID'];
    this.appService.eviDocuments(v1);
    this.isProcessing = false;
  }
  //cer start
  visibleCertificationPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('certificationPopup', { static: true }) certificationPopup: TemplateRef<any>;
  certificationPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '100px' },
  };
  isDefaultTemplate: boolean = false;
  isWithScoreTemplate: boolean = false;
  certificateTemplate: any = {};
  certificateData: any;
  oneQmsOrgImagesDetails: any = {};
  orgData: any = {};
  isEsignRequired: boolean = false;
  reasonForSign: any;
  userDetails: any = {};
  trainingData: any = {};
  cerDownload(value: any) {
    const v1 = value['USER_TRAINING_ID'];
    const v2 = value['USER_ID'];


    // 1. ✅ Reset state FIRST (Exact same reset as your original)
    this.isProcessing = true;
    this.userDetails = {};
    this.trainingData = {};
    this.certificateTemplate = null;
    this.certificateData = null;
    this.isDefaultTemplate = false;
    this.isWithScoreTemplate = false;

    // 2. Fetch Training Data
    this.appService.getUserTrainingsByTrainingId(v1).subscribe((data: any) => {
      this.trainingData = data[0] || {};

      // 3. Fetch User Details
      this.appService.getUserDetailsForTrainingDashboard(v2).subscribe((userData: any) => {
        this.userDetails = userData[0] || {};

        // 4. Decide Template Path
        this.isProcessing = true; // Kept your redundant reset to ensure 1:1 behavior
        this.isWithScoreTemplate = !!this.trainingData.finalScore;

        this.fetchAndProcessCertificateTemplates();
      });
    });
  }

  private fetchAndProcessCertificateTemplates(): void {
    this.appService.getTrainingCertificateTemplates().subscribe({
      next: (templates: any) => {
        // 5. Determine which "Default" flag to look for based on score
        const searchKey = this.isWithScoreTemplate
          ? 'isDefaultWithscoreTemplate'
          : 'isDefaultWithoutscoreTemplate';

        // 6. Find the 'Y' template (Exact same mapping as your original find)
        this.certificateTemplate = templates.find((item: any) => item[searchKey] === "Y") || null;

        if (this.certificateTemplate?.template) {
          this.isDefaultTemplate = true;
          this.buildCertificateData(this.certificateTemplate.template);
        } else {
          this.isDefaultTemplate = false;
        }

        this.finalizeCerDownload();
      },
      error: (error) => {
        console.error('Template load error:', error);
        this.finalizeCerDownload();
      }
    });
  }

  private finalizeCerDownload(): void {
    this.isProcessing = false;
    this.visibleCertificationPopup = this.dialog.open(this.certificationPopup, this.certificationPopupConfig);
  }
  buildCertificateData(data: any) {
    const replacePlaceholder = (placeholder: string, replacement: any) => {
      return data.includes(placeholder) ? data.split(placeholder).join(replacement ?? "") : data;
    };
    data = replacePlaceholder("&lt;PERCENTAGE&gt;", this.trainingData.finalScore);
    data = replacePlaceholder("&lt;ORG_NAME&gt;", this.orgData.orgLongName);
    if (data.includes("&lt;ORG_LOGO&gt;")) {
      const logo = this.oneQmsOrgImagesDetails?.logoImage ?? "";
      data = data.split("&lt;ORG_LOGO&gt;").join(logo);
    }
    data = replacePlaceholder("&lt;TRAINING_NAME&gt;", this.trainingData.trainingName);
    if (data.includes("&lt;TRAINING_TYPE&gt;")) {
      data = data.split("&lt;TRAINING_TYPE&gt;").join(this.trainingData.type);
    }
    if (data.includes("&lt;COMPLETED_ON&gt;")) {
      const date = this.convertTZ(new Date(this.trainingData.completedOn), localStorage.getItem("timezone") ? localStorage.getItem("timezone") : "GMT")
      data = data.split("&lt;COMPLETED_ON&gt;").join(date);
    }
    data = replacePlaceholder("&lt;USER_FIRST_NAME&gt;", this.userDetails.firstName);
    data = replacePlaceholder("&lt;USER_LAST_NAME&gt;", this.userDetails.lastName);
    data = replacePlaceholder("&lt;REASON_FOR_SIGN&gt;", this.reasonForSign);
    data = replacePlaceholder("&lt;USER_DESIGNATION&gt;", this.userDetails.designation);
    this.certificateData = this.sanitizer.bypassSecurityTrustHtml(data);
  }
  public downloadAsPdf(): void {
    let data: any;
    if (this.isDefaultTemplate) {
      data = document.getElementById('dataToExportFromTemp');  //Id of the table
    } else {
      data = document.getElementById('dataToExport');  //Id of the table
    }
    html2canvas(data).then(canvas => {
      let imgWidth = 208;
      let imgHeight = canvas.height * imgWidth / canvas.width;
      const contentDataURL = canvas.toDataURL('image/png')
      let pdf = new jspdf('p', 'mm', 'a4'); // A4 size page of PDF
      let position = 0;
      pdf.addImage(contentDataURL, 'PNG', 0, position, imgWidth, imgHeight)
      pdf = this.addWaterMark(pdf);
      pdf.save('Certificate.pdf'); // Generated PDF
    });
  }

  addWaterMark(doc: any) {
    let timezone;
    if (localStorage.getItem("timezone") && localStorage.getItem("timezone") != null && localStorage.getItem("timezone") != "null") {
      console.log("timezone==", localStorage.getItem("timezone"));
      timezone = localStorage.getItem("timezone");
    } else {
      console.log("timezone=", "GMT");
      timezone = "GMT";
    }
    let totalPages = doc.internal.getNumberOfPages();
    let watermark = "Printed by: " + localStorage.getItem("loggedUserName") + " | Printed on: " + this.convertTZ(new Date(), timezone) + "(" + timezone + ")";
    for (let i = 1; i <= totalPages; i++) {
      const fontSize = 12;
      doc.setPage(i);
      doc.setFontSize(fontSize);
      doc.setTextColor(150);
      doc.text(5, doc.internal.pageSize.height - 5, watermark);
    }
    return doc;
  }
  convertDateAndTime(date: Date) {
    const monthNames = ["Jan", "Feb", "Mar", "Apr",
      "May", "Jun", "Jul", "Aug",
      "Sep", "Oct", "Nov", "Dec"];
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const monthName = monthNames[monthIndex];
    const year = date.getFullYear();
    return `${day}-${monthName}-${year} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
  }
  convertDate(date: any) {
    const monthNames = ["Jan", "Feb", "Mar", "Apr",
      "May", "Jun", "Jul", "Aug",
      "Sep", "Oct", "Nov", "Dec"];
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const monthName = monthNames[monthIndex];
    const year = date.getFullYear();
    return `${day}-${monthName}-${year}`
  }
  // end cer
  //audit trails
  auditTrail: any = {};
  @ViewChild(StaticAuditTrailComponent) staticAuditTrailComponent!: StaticAuditTrailComponent;
  openAuditTrail(certificate: any) {
    let v1 = certificate['USER_TRAINING_ID'];
    this.message.tableOrView_Name = "TMS_USER_TRAININGS_REP_AU_VW";
    this.message.columnList_DB =
      'CREATED_TS,END_TS,ACTION_FLAG,LOCKED_ON,NO_OF_OVERDUE_UNLOCK,NO_OF_FAILED_UNLOCK,NO_OF_TIMES_COMPLETED,TRAINING_SCHEDULE_ID,SCHEDULED_TRAINING_STATUS,TRAINER_ID,TRAINER_NAME,SCHEDULED_TRAINING_ASSESSMENT,START_DATE,END_DATE,VERSION,TRAINING_NAME,TRAINING_CODE,EXPIRY_DATE,USER_TRAINING_STATUS,STARTED_ON,COMPLETED_ON,CATEGORY_CODE,TYPE,TOTAL_DURATION,LANGUAGE,IS_LATEST_VERSION,IS_LATEST_PUBLISHED_VERSION,GROUP_NAME,IS_GROUP_ACTIVE,TRAINING_LEVEL,DUE_N_DAY_FROM_ASSIGNED,REMIND_N_DAY_BEFORE_DUE,REMIND_EVERY_N_DAYS,ESCALATE,ESCALATE_EVERY_N_DAYS,REPEAT_TRAINING,REPEAT_INTERVAL,REPEAT_INTERVAL_UNIT,ALLOWED_FAILED_ATTEMPTS,ALLOWED_FAILED_ATTEMPTS_AFTER_UNLOCK,MAX_ALLOWED_FAILED_ATTEMPTS,ALLOW_TO_REVIEW_RESULTS,SHOW_ANSWERS_AT_REVIEW,OVERDUE_RM_APPROVAL_REQD,OVERDUE_QA_APPROVAL_REQD,LIST_OF_QA_USERS_NAME,DUE_N_DAY_FROM_OVERDUE_UNLOCK,RETAKE_AFTER_N_MIN_ON_FAILED_ATTEMPT,TRAINING_ASSIGNED_ON,TRAINING_ASSIGNED_BY_USER,IS_TRAINING_AT_GROUP_ACTIVE,IS_USER_AT_GROUP_ACTIVE,USER_NAME,USR_FULLNAME,DESIGNATION_CODE,DEPARTMENT_CODE,MANAGER_USERNAME,MANAGER_FULLNAME,IS_USER_ACTIVE,EMAIL_ADDRESS,INTIMATION_SCHEDULED,INTIMATION_SENT_ON,REMINDER_SENT_ON,ESCALATION_SENT_ON,MARKED_AS_COMPLETED_BY_USER,EVIDENCE_DOC_ID,COMMENTS,FINAL_SCORE,FAILED_ATTEMPTS,FAILED_ATTEMPTS_AFTER_UNLOCK,FAILED_ATTEMPT_REACHED,MAX_FAILED_ATTEMPT_REACHED,RELAUNCH_REASON,ESIGNATURE_DONE,FAILED_LOCK_RM_APPROVED_ON,OVERDUE_LOCK_RM_APPROVED_ON,OVERDUE_LOCK_QA_APPROVED_ON,OVERDUE_LOCK_QA_USER_ID,RM_USER_ID,FAILED_ON';
    this.message.columnList_UI = "Timestamp Created,Timestamp Ended,Action Flag,Locked On,No. of Overdue Unlocks,No. of Failed Unlocks,No. of Times Completed,Training Schedule ID,Scheduled Training Status,Trainer ID,Trainer Name,Scheduled Training Assessment,Start Date,End Date,Version,Training Name,Training Code,Expiry Date,User Training Status,Started On,Completed On,Category Code,Type,Total Duration,Language,Is Latest Version,Is Latest Published Version,Group Name,Is Group Active,Training Level,Due N Days from Assigned,Remind N Days Before Due,Remind Every N Days,Escalate,Escalate Every N Days,Repeat Training,Repeat Interval,Repeat Interval Unit,Allowed Failed Attempts,Allowed Failed Attempts After Unlock,Max Allowed Failed Attempts,Allow to Review Results,Show Answers at Review,Overdue RM Approval Required,Overdue QA Approval Required,List of QA Users Name,Due N Days from Overdue Unlock,Retake After N Minutes on Failed Attempt,Training Assigned On,Training Assigned By,Is Training at Group Active,Is User at Group Active,User Name,User Fullname,Designation Code,Department Code,Manager Username,Manager Fullname,Is User Active,Email Address,Intimation Scheduled,Intimation Sent On,Reminder Sent On,Escalation Sent On,Marked as Completed By,Evidence Document ID,Comments,Final Score,Failed Attempts,Failed Attempts After Unlock,Failed Attempt Reached,Max Failed Attempt Reached,Relaunch Reason,ESignature Done,Failed Lock RM Approved On,Overdue Lock RM Approved On,Overdue Lock QA Approved On,Overdue Lock QA User ID,RM User ID,Failed On";
    this.message.whereClause_AU = " AND USER_TRAINING_ID=" + v1;
    this.message.columnList_Report = "Timestamp Created,Timestamp Ended,Action Flag,Locked On,No. of Overdue Unlocks,No. of Failed Unlocks,No. of Times Completed,Training Schedule ID,Scheduled Training Status,Trainer ID,Trainer Name,Scheduled Training Assessment,Start Date,End Date,Version,Training Name,Training Code,Expiry Date,User Training Status,Started On,Completed On,Category Code,Type,Total Duration,Language,Is Latest Version,Is Latest Published Version,Group Name,Is Group Active,Training Level,Due N Days from Assigned,Remind N Days Before Due,Remind Every N Days,Escalate,Escalate Every N Days,Repeat Training,Repeat Interval,Repeat Interval Unit,Allowed Failed Attempts,Allowed Failed Attempts After Unlock,Max Allowed Failed Attempts,Allow to Review Results,Show Answers at Review,Overdue RM Approval Required,Overdue QA Approval Required,List of QA Users Name,Due N Days from Overdue Unlock,Retake After N Minutes on Failed Attempt,Training Assigned On,Training Assigned By,Is Training at Group Active,Is User at Group Active,User Name,User Fullname,Designation Code,Department Code,Manager Username,Manager Fullname,Is User Active,Email Address,Intimation Scheduled,Intimation Sent On,Reminder Sent On,Escalation Sent On,Marked as Completed By,Evidence Document ID,Comments,Final Score,Failed Attempts,Failed Attempts After Unlock,Failed Attempt Reached,Max Failed Attempt Reached,Relaunch Reason,ESignature Done,Failed Lock RM Approved On,Overdue Lock RM Approved On,Overdue Lock QA Approved On,Overdue Lock QA User ID,RM User ID,Failed On";
    this.message.whereClause_Report = " WHERE USER_TRAINING_ID=" + v1;
    this.message.report_And_Popup_Name = "Training Report Audit Trail";
    this.message.columnList_INVISIBLE = "LIST_OF_QA_USERS";
    this.staticAuditTrailComponent.triggerTrail(certificate);
  }
  //audit trails end
  applyFilter(column: string, event: Event, val: any): void {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    console.log(column + "=====" + filter + "====" + val)
    if (filter === '') {
      this.pagedItemsSecond = this.tmsUserTrainingsRepVwDataForGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
      this.searchValue = '';
    } else {
      this.pagedItemsSecond = this.tmsUserTrainingsRepVwDataForGrid.filter((item: any) => {
        const columnValue = item[column];
        // Check if columnValue is a string before calling toLowerCase()
        if (val === 'd') {
          if (columnValue) {
            let formattedDate = this.datePipe.transform(columnValue, 'dd-MMM-yyyy');
            console.log("columnValue2=", formattedDate);
            // Convert number to string before checking for inclusion
            return formattedDate ? formattedDate.toString().toLowerCase().includes(filter) : false;
          } else {
            return false;
          }
        } else if (typeof columnValue === 'string') {
          return columnValue.toLowerCase().includes(filter);
        } else if (typeof columnValue === 'number') {
          // Convert number to string before checking for inclusion
          return columnValue.toString().toLowerCase().includes(filter);
        } else if (columnValue instanceof Date) {
          // Format date to string before checking for inclusion
          const formattedDate = columnValue.toISOString().substring(0, 10);
          return formattedDate.toLowerCase().includes(filter);
        }
        // If it's not a string, return false to exclude it from filtering
        return false;
      });
    }
    this.setPage(1, 1);
  }


  onFileSelected(event: any) {
    console.log("=====file uploaded======");
    const selectedFilesArray = event.target.files;
    this.file = selectedFilesArray[0];
    this.filename = this.file.name.substr(0, this.file.name.lastIndexOf('.'));
    this.fileExtension = (this.file.name.split('.').pop() ?? '').toLowerCase();
    const formData = new FormData();
    formData.append('file', this.file);
    formData.append('pageName', 'ORG');
    formData.append('fileName', this.filename);
    formData.append('extension', this.fileExtension);
    this.isProcessing = true;
    this.appService.fileUploadToServer(formData).subscribe({
      next: (response: any) => {
        this.isProcessing = false;
        console.log("response.resultType=", response.resultType);
        if (response.resultType == 'S') {
          this.markasCompletedBtndisable = false;
          this.markResult = "";
          this.resultType = "";
        } else {
          this.showSnackBar(response.result, response.resultType);
          this.markasCompletedBtndisable = true;
          this.markResult = response.result;
          this.resultType = response.resultType;
        }
      },
      error: (error) => {
        this.isProcessing = false;
        this.markasCompletedBtndisable = true;
        this.markResult = error;
        this.resultType = "Internal server error";
        throw error;
      }
    })
  }

  @ViewChild('captureDiv') captureDiv!: ElementRef;
  captureElement(): void {
    const element = this.captureDiv.nativeElement;
    html2canvas(element, {
      scrollX: -window.scrollX,
      scrollY: -window.scrollY,
      windowWidth: document.documentElement.offsetWidth,
      windowHeight: document.documentElement.offsetHeight,
    }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF();
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
      // Add the image to the PDF with the calculated height to maintain aspect ratio
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      // Save the PDF
      pdf.save(this.selectedOption + '.pdf');
    });
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });
    sb.onAction().subscribe(() => {
      sb.dismiss();
    });
  }
  excelDownloadMaingridOrg(types: any) {
    let considerForReportFlag = "";
    let attaptedVal = "";
    let typeVal = "";
    let vals = "";

    considerForReportFlag = "NeedConsiderForReport";
    attaptedVal = "notatt";
    let tname = "";
    let colList = "";
    let fieldList = "";
    this.whereValsForExcel = "";
    tname = "TMS_USER_TRAININGS_REP_CNT_VW";
    if (types == 'user') {
      typeVal = "user";
      vals = '01010';
      colList = "USR_FULLNAME,TOTAL,YET_TO_BE_ATTEMPTED,ATTEMPTED,COMPLETED_AT_ATTEMPTED_CHART,FAILED_AT_ATTEMPTED_CHART,SCHEDULED_AT_ATTEMPTED_CHART,FAILED_ATTEMPTS,PASS,USER_ID";
      fieldList = "User Fullname,Total,Yet To Be Attempted,Attempted,Completed,Failed,Scheduled,Failed Attempts,Pass %,User ID";

    } else if (types == 'training') {
      typeVal = "tr";
      vals = '01010';
      colList = "TRAINING_NAME,VERSION,TOTAL,YET_TO_BE_ATTEMPTED,ATTEMPTED,COMPLETED_AT_ATTEMPTED_CHART,FAILED_AT_ATTEMPTED_CHART,SCHEDULED_AT_ATTEMPTED_CHART,FAILED_ATTEMPTS,PASS";
      fieldList = "Training Name,Version,Total,Yet To Be Attempted,Attempted,Completed,Failed,Scheduled,Failed Attempts,Pass %";
    }
    this.whereValsForExcel = "";
    const data = {

      groupId: null,
      type: typeVal,
      val: vals,
      attaptedVal: attaptedVal,
      considerForReportFlag: considerForReportFlag
    }
    const data1: any = {
      tableOrViewName: tname,
      columnsList: colList,
      fieldLabelsList: fieldList,
      invisibleColumn: "",
      orderByClause: "",
      fieldSizeList: "",
      columnsListarray: [],
      fieldColumnarray: [],
      invisibleColumnarray: 'USER_ID',
      fieldSizeListArray: [],
      status: null,
      codelistGroup: null,
      manualEntryDataFields: null,
      groupId: this.qmsservice.selectedActivityGroupId,
      chartStatus: null,
      wherVal: this.whereValsForExcel,
      reModule: "tms"
    }

    this.reportObj = { ...data1, ...data };
    debugger;
    const pdfData = {
      ...this.reportObj, "footer": this.selectedReportFooter, title: this.selectedOption + "-" + this.selectedStatus, columns: [],
      "informationTab": {
        "Report Name": this.selectedOption,
        "Exported By": localStorage.getItem("loggedUserName")
      }
    }
    this.appService.downloadexcelForMainGrid(pdfData, this.selectedOption + ".xlsx");
  }
  getDetailsOrg(listOfUsersData: any) {
    this.getOneQmsUsersTrainingsRepVwUserCountByor = [];
    this.getOneQmsUsersTrainingsRepVwTrainingCountByOr = [];
    this.tempOrgIdForUserTrainingExcel = listOfUsersData.orgId;
    this.detailsGridGetCallOrgTrainingUsers('users', 's', "noStatus", listOfUsersData);
  }
  userlevelClickedOrgId: any;
  getDetailsOrgUsers(listOfUsersData: any) {
    this.getOneQmsUsersTrainingsRepVw = [];
    this.getOneQmsUsersTrainingsRepVwUserCountByor = [];
    this.getOneQmsUsersTrainingsRepVwTrainingCountByOr = [];
    this.whereValsForExcelTempOrg = "";
    if (this.showTrainingContents) {
      this.columnList = "User Name,User Fullname,Training Name,Training Level,Version,Training Code,Training Type,Training Contents,Group Name,Status,Is User Active,Designation Code,Department Code,Manager Fullname,Trainer Name,User Training Status,Scheduled Training Status,Expiry Date,Due Date,Training Assigned On,Intimation Sent On,Started On,Completed On,Reminder Sent On,Escalation Sent On,Locked On,Failed Lock Rm Approved On,Overdue Lock Qa Approved On,Overdue Lock Rm Approved On,Start Date,End Date,Comments,Evidence Doc Id,Failed Attempts,Final Score";
    } else {
      this.columnList = "User Name,User Fullname,Training Name,Training Level,Version,Training Code,Training Type,Group Name,Status,Is User Active,Designation Code,Department Code,Manager Fullname,Trainer Name,User Training Status,Scheduled Training Status,Expiry Date,Due Date,Training Assigned On,Intimation Sent On,Started On,Completed On,Reminder Sent On,Escalation Sent On,Locked On,Failed Lock Rm Approved On,Overdue Lock Qa Approved On,Overdue Lock Rm Approved On,Start Date,End Date,Comments,Evidence Doc Id,Failed Attempts,Final Score";
    }
    let vals = "";
    vals = "NeedConsiderForReport";
    this.isProcessing = true;
    this.userlevelClickedOrgId = listOfUsersData.orgId;
    this.tempOrgIdForUserTrainingExcel = listOfUsersData.orgId;
    this.appService.getOneQmsUserTrainingsRepVwUsersCountByOrg('or', vals, listOfUsersData.orgId).subscribe((data: any) => {
      this.getOneQmsUsersTrainingsRepVwUserCountByor = data;
      this.calculateTotalPages4th = this.collectionSize4th / this.perPage4th;
      this.pager4th.totalPages = undefined;
      this.collectionSize4th = this.getOneQmsUsersTrainingsRepVwUserCountByor.length;
      this.totalPages4th = Math.ceil(this.getOneQmsUsersTrainingsRepVwUserCountByor.length / this.itemsPerPage4th);
      this.setPage4th(1, 0);
      this.isProcessing = false;
    })
  }
  whereValsForExcelTempOrg: any;
  tempOrgIdForUserTrainingExcel: any;
  getDetailsOrgTrainings(listOfUsersData: any) {
    this.getOneQmsUsersTrainingsRepVw = [];
    this.getOneQmsUsersTrainingsRepVwUserCountByor = [];
    this.getOneQmsUsersTrainingsRepVwTrainingCountByOr = [];
    this.whereValsForExcelTempOrg = "";
    if (this.showTrainingContents) {
      this.columnList = "User Name,User Fullname,Training Name,Training Level,Version,Training Code,Training Type,Training Contents,Group Name,Status,Is User Active,Designation Code,Department Code,Manager Fullname,Trainer Name,User Training Status,Scheduled Training Status,Expiry Date,Due Date,Training Assigned On,Intimation Sent On,Started On,Completed On,Reminder Sent On,Escalation Sent On,Locked On,Failed Lock Rm Approved On,Overdue Lock Qa Approved On,Overdue Lock Rm Approved On,Start Date,End Date,Comments,Evidence Doc Id,Failed Attempts,Final Score";
    } else {
      this.columnList = "User Name,User Fullname,Training Name,Training Level,Version,Training Code,Training Type,Group Name,Status,Is User Active,Designation Code,Department Code,Manager Fullname,Trainer Name,User Training Status,Scheduled Training Status,Expiry Date,Due Date,Training Assigned On,Intimation Sent On,Started On,Completed On,Reminder Sent On,Escalation Sent On,Locked On,Failed Lock Rm Approved On,Overdue Lock Qa Approved On,Overdue Lock Rm Approved On,Start Date,End Date,Comments,Evidence Doc Id,Failed Attempts,Final Score";
    }
    this.tempOrgIdForUserTrainingExcel = listOfUsersData.orgId;
    let vals = "";
    vals = "NeedConsiderForReport";
    this.isProcessing = true;
    this.appService.getOneQmsUserTrainingsRepVwTrainingCountByOrg('or', vals, listOfUsersData.orgId).subscribe((data: any) => {
      this.getOneQmsUsersTrainingsRepVwTrainingCountByOr = data;
      let ii = 0;
      data.forEach((item: any, index: any) => {
        const itemObj = this.dropDownForOrg.filter((d: { orgId: any; }) => d.orgId === this.getOneQmsUsersTrainingsRepVwTrainingCountByOr[ii].orgId);
        this.getOneQmsUsersTrainingsRepVwTrainingCountByOr[ii].orgName = itemObj[0].orgLongName;
        ii++;
      });
      this.calculateTotalPages3rd = this.collectionSize3rd / this.perPage3rd;
      this.pager3rd.totalPages = undefined;
      this.collectionSize3rd = this.getOneQmsUsersTrainingsRepVwTrainingCountByOr.length;
      this.totalPages3rd = Math.ceil(this.getOneQmsUsersTrainingsRepVwTrainingCountByOr.length / this.itemsPerPage3rd);
      this.setPage3rd(1, 0);
      this.isProcessing = false;
    })
  }
  getDetailsOrgTraining(listOfUsersData: any, status: any, type: any) {
    this.pagedItemsSecond = [];
    this.getOneQmsUsersTrainingsRepVw = {};
    this.showOnlyConsider = false;
    this.searchByReson = null;
    this.showTrainingContents = false;
    console.log("yes", this.showOnlyConsider);
    let whereVal = "";
    let idField = "";
    let nameField = "";
    if (type === 'users') {
      whereVal = " AND USER_ID='" + listOfUsersData.userId + "'";
    } else if (type === 'training') {
      whereVal = " AND TRAINING_ID='" + listOfUsersData.trainingId + "'";
    }
    this.selectedStatus = listOfUsersData[nameField] + "-" + this.statusVal(status);

    if (status !== "All") {
      if (status === "OVERDUE") {
        whereVal += " AND (OVERDUE=1 OR LOCKED_OVERDUE=1)";
      } else if (status === "LOCKED") {
        whereVal += " AND (LOCKED=1 OR PERMENANTLY_LOCKED=1)";
      } else {
        whereVal += ` AND ${status}=1`;
      }
    }
    this.detailsGridGetCallOrgTrainingUsers(type, "s", whereVal, listOfUsersData);
  }

  detailsGridGetCallOrgTrainingUsers(type: any, val: any, whereVal: any, obj: any) {
    this.isProcessing = true;
    let tempOrgId = null;
    if (type == 'user') {
      tempOrgId = this.userlevelClickedOrgId;
    } else {
      tempOrgId = obj.orgId;
    }
    this.tempOrgIdForFlag = tempOrgId;
    this.selectedStatus = "Users";
    this.tmsUserTrainingsRepVwDataForGrid = [];
    const data = {

      gridName: "TMS_REPORTS",
      groupId: null
    }
    this.appService.getDynamicGridHeaders(data).subscribe({
      next: (response: any) => {

        response.orderByClause ??= "";

        this.makeStickyColumns = response.fixedFieldCnt;
        let data1: any;
        data1 = {

          gridName: "TMS_REPORTS",
          tableOrViewName: response.tableOrViewName ?? "",
          columnsList: response.columnsList ?? "",
          fieldLabelsList: response.fieldLabelsList ?? "",
          invisibleColumn: response.invisibleColumn ?? "",
          orderByClause: response.orderByClause ?? "",
          fieldSizeList: response.fieldSizeList ?? "",
          columnsListarray: [],
          fieldColumnarray: [],
          invisibleColumnarray: [],
          fieldSizeListArray: [],
          selectedUserId: null,
          selectedFolderPath: null,
          selectedDocumentTypeName: null,
          selectedDocContainer: null,
          manualEntryDataFields: "DUE_DATE" + response.manualEntryDataFields,
          clobColumnlist: response.closblist || "",
          blobColumnlist: response.bloblist || "",
          wherVal: whereVal == "noStatus" ? "" : whereVal,
          isConsider: this.message.showRetakeAndMarkasCompleted ? "" : "Y"
        }

        this.appService.usergridddynamicDataForTmsReport(data1).subscribe({
          next: (response1: any) => {
            this.isProcessing = false;
            this.tmsUserTrainingsRepVwDataForGrid = response1;
            data1.columnsListarray = data1.columnsList.split(",");
            data1.fieldColumnarray = data1.fieldLabelsList.split(",");
            data1.invisibleColumnarray = data1.invisibleColumn.split(",");
            data1.fieldSizeListArray = data1.fieldSizeList.split(",");
            let rendereddata: any;
            this.columnLists.columnsListarray = data1.columnsListarray;
            this.columnLists.fieldLabelsList = data1.fieldLabelsList;
            this.columnLists.fieldColumnarray = [];
            for (let p = 0; p < data1.fieldColumnarray.length; p++) {
              this.columnLists.fieldColumnarray.push({
                "fieldColumnarray": data1.fieldColumnarray[p],
                "width": data1.fieldSizeListArray[p] + 'px'
              })
            }
            this.columnLists.invisibleColumnarray = data1.invisibleColumnarray;
            this.columnLists.fieldSizeListArray = [];
            for (const size of data1.fieldSizeListArray) {
              this.columnLists.fieldSizeListArray.push(size + 'px');
            }
            for (let y = this.columnLists.columnsListarray.length - 1; y >= 0; y--) {
              if (this.columnLists.invisibleColumnarray.includes(this.columnLists.columnsListarray[y])) {
                this.columnLists.columnsListarray.splice(y, 1);
                this.columnLists.fieldColumnarray.splice(y, 1);
                this.columnLists.fieldSizeListArray.splice(y, 1);
              }
            }
            let tableData = {
              tablename: data1.tableOrViewName
            };
            this.columnLists.columnsListarray1 = [];
            this.appService.tableFieldsDataType(tableData).subscribe((response2: any) => {
              this.dataTypeList = response2;
              for (let m = 0; m < this.columnLists.columnsListarray.length; m++) {
                this.columnLists.columnsListarray1.push({});
                this.columnLists.columnsListarray1[m].columnsListarray = this.columnLists.columnsListarray[m];
                this.columnLists.columnsListarray1[m].dataType = "textbox";
                this.columnLists.columnsListarray1[m].width = this.columnLists.fieldSizeListArray;
                for (const dataType of this.dataTypeList) {
                  if (dataType.columnName === this.columnLists.columnsListarray[m]) {
                    this.columnLists.columnsListarray1[m].dataType = dataType.fieldType;
                  }
                }
              }
              for (const record of this.tmsUserTrainingsRepVwDataForGrid) {
                for (const dataType of this.dataTypeList) {
                  if (dataType.fieldType === 'CHECKBOX') {
                    record[dataType.columnName] = record[dataType.columnName] === "Y";
                  }
                }
              }
              this.calculateTotalPagesSecond = this.collectionSizeSecond / this.perPageSecond;
              this.pagerSecond.totalPages = undefined;
              this.setPageSecond(1, 0);
            });
            this.message.gridList = this.tmsUserTrainingsRepVwDataForGrid;
            this.collectionSizeSecond = this.tmsUserTrainingsRepVwDataForGrid.length;
            this.totalPagesSecond = Math.ceil(this.tmsUserTrainingsRepVwDataForGrid.length / this.itemsPerPageSecond);
          }, error: (error: any) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
    this.typeValForflag = type;
    this.whereValsForExcelTemp = "";
    this.whereValsForExcelTemp = whereVal;
    console.log("this.whereValsForExcelTemp=", this.whereValsForExcelTemp);


  }
  setPage3rd(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages3rd) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager3rd = this.paginationService.getPager(this.getOneQmsUsersTrainingsRepVwTrainingCountByOr.length, page, this.perPage3rd, targetpage);
    if (this.getOneQmsUsersTrainingsRepVwTrainingCountByOr.length > 0) {
      this.pagedItems3rd = this.getOneQmsUsersTrainingsRepVwTrainingCountByOr.slice(this.pager3rd.startIndex, this.pager3rd.endIndex + 1);
    }
  }

  paginationCall4th(value: number) {
    this.perPage = value;
    this.setPage4th(this.pager.currentPage, 0);
  }
  setPage4th(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages4th) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pager4th = this.paginationService.getPager(this.getOneQmsUsersTrainingsRepVwUserCountByor.length, page, this.perPage4th, targetpage);
    if (this.getOneQmsUsersTrainingsRepVwUserCountByor.length > 0) {
      this.pagedItems4th = this.getOneQmsUsersTrainingsRepVwUserCountByor.slice(this.pager4th.startIndex, this.pager4th.endIndex + 1);
    }
  }

  paginationCall3rd(value: number) {
    this.perPage = value;
    this.setPage3rd(this.pager.currentPage, 0);
  }
  //setting reorder start
  @ViewChild(GridReorderComponent) gridReorderComponent!: GridReorderComponent;
  openReorder() {
    this.gridReorderComponent.reordercall("TMS_REPORTS", "TMS_USER_TRAININGS_REP_CNT_VW", null, 0);
  }
  onChildValueEmitted() {
    console.log("refresh");
    this.detailsGridGetCall(this.currentType, null, this.currentWhereVal);
  };

  getClobData(list: any, colunName: any) {
    console.log("a")
  }

  statusVal(val: any) {
    if (val == "All") {
      return "Total";
    } else if (val == "OVERDUE") {
      return "Overdue";
    } else if (val == "LOCKED") {
      return "Locked";
    } else if (val == "COMPLETED_AT_ATTEMPTED_CHART" || val == "COMPLETED") {
      return "Completed";
    } else if (val == "YET_TO_BE_ATTEMPTED") {
      return "Yet To Be Attempted";
    } else if (val == "ATTEMPTED") {
      return "Attempted";
    } else if (val == "FAILED_AT_ATTEMPTED_CHART" || val == "FAILED") {
      return "Failed";
    } else if (val == "WITHDRAWN") {
      return "Withdrawn";
    } else if (val == "SCHEDULED_AT_ATTEMPTED_CHART" || val == "SCHEDULED") {
      return "Scheduled";
    } else if (val == "PENDING") {
      return "Pending";
    } else if (val == "INPROGRESS") {
      return "Inprogress";
    } else if (val == "noOfUsers") {
      return " ";
    } else {
      return val;
    }
  }

  convertTZ(date: any, timezone: any) {
    if (localStorage.getItem("timezone") && localStorage.getItem("timezone") != null && localStorage.getItem("timezone") != "null") {
      console.log("timezone==", localStorage.getItem("timezone"));
      timezone = localStorage.getItem("timezone");
    } else {
      console.log("timezone=", "GMT");
      timezone = "GMT";
    }
    let dt = new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", { timeZone: timezone }));
    let month_names = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    let date2 = dt.getFullYear() + "-" + month_names[dt.getMonth()] + "-" + dt.getDate();
    let date1 = moment(date2).format(this.appService.organizationDetails?.htmlDateFormat == null ? 'DD-MMM-YYYY' : this.appService.organizationDetails?.htmlDateFormat.toUpperCase());
    let hours = dt.getHours();
    let minutes: any = dt.getMinutes();
    let ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours || 12;
    minutes = minutes < 10 ? '0' + minutes : minutes;
    let strTime = hours + ':' + minutes + ' ' + ampm;
    return date1 + " " + strTime;
  }

  cancelCer() {
    this.visibleCertificationPopup.close();

  }

}
